import {
  getEvent,
  saveZoneSettings,
  saveFlashSeatSettings,
  saveOriginalTemplate,
  getPrintTemplates,
  checkEventLookupId,
  saveEvent,
  getCheckForEventOverlap,
  searchArtists,
  searchPromoters,
  getTemplates,
  getTemplate,
  getVenueMaps,
  publishEvent,
  searchSites,
  getEventRevisions,
  getAxsManagers,
  getVenueManagers,
  createCMSEvent,
  getEmailTemplates,
  getTaxProfiles,
  saveAutoPublishOffer,
  getLDFlagValue,
  getShortCodes,
  logoutAndRedirect,
} from '../../../api/ApiManager';
import { browserHistory } from 'react-router';
import find from 'lodash/find';
import get from 'lodash/get';
import findIndex from 'lodash/findIndex';
import cloneDeep from 'lodash/cloneDeep';
import moment from 'moment/moment';
import { dateFormats } from '../../../common/constants/dateFormats';
import {
  receiveAndFormatEvent,
  receiveAndFormatPortalOnlyEvent,
  receiveAndFormatPortalTemplateBaseEvent,
  receiveAndFormatZones,
  receiveAndFormatTemplateBaseEvent,
  receiveAndFormatTemplateDates,
} from '../../../common/lib/ReceiveAndFormatDates';
import { selectFeatureFlag } from '@flopflip/react-redux';
import Logger from '../../../common/lib/Logger';
import { flags } from '../../../common/constants/flags';
import * as actions from './constants';
import {
  START_FIELD_ID,
  END_FIELD_ID,
  ONSALE_FIELD_ID,
  ETICKET_FIELD_ID,
  FLASH_FIELD_ID,
  DOOR_DATE_FIELD_ID,
  ANNOUNCEMENT_FIELD_ID,
  STANDARD_DELIVERY_DATE_FIELD_ID,
  ACCESS_START_FIELD_ID,
  ACCESS_END_FIELD_ID,
  EXPIRATION_DATE_FIELD_ID,
} from '../../../common/components/RelativeDateAndTime/constants/index';
import {
  UPDATE_NOTIFICATION,
  updateNotification,
  setDataModifiedWarning,
} from '../../../store/app';
import { LOAD_TEMPLATES_SUCCESS } from '../../Templates/modules/templateChron';
import { DefaultGenre1, DefaultGenre2, DefaultGenre3 } from '../constants';

import camelcaseKeysDeep from 'camelcase-keys-deep';
import calculateRelativeDate from '../../../common/lib/CalculateRelativeDate';
import removeRelativeDateValues from '../../../common/lib/RemoveRelativeDate';
import { sortGenres } from '../helpers';
import {
  formatEventsCategory,
  formatSeasonsCategory,
  getIsPublicEDP,
} from '../../Templates/common/helpers';

import { setAndHideNotification } from '../routes/EditOffer/modules/EditOfferModule';
import {
  setLDFlag,
  SET_LD_FLAG,
} from '../routes/admissions/modules/admissions';

export const CALCULATE_RELATIVE_DATES = 'CALCULATE_RELATIVE_DATES';
export const REMOVE_RELATIVE_DATE = 'REMOVE_RELATIVE_DATE';
export const HANDLE_PROMOTER_CHANGE = 'HANDLE_PROMOTER_CHANGE';

export const handleCreateCMSEvent = () => {
  return {
    type: actions.HANDLE_CREATE_CMS_EVENT,
  };
};
export const toggleIsSaving = (setting) => {
  return {
    type: actions.SET_IS_SAVING_FLAG,
    setting,
  };
};

export const toggleIsLoading = (setting) => {
  return {
    type: actions.SET_IS_LOADING_FLAG,
    setting,
  };
};

export const checkEventLookupIdBegin = () => {
  return {
    type: actions.EVENT_LOOKUPID_CHECK_BEGIN,
  };
};

export const removeRelativeDate = (fieldId) => {
  return { type: REMOVE_RELATIVE_DATE, fieldId };
};

export const checkEventLookupIdFailure = (failureMessage) => {
  return {
    type: actions.EVENT_LOOKUPID_CHECK_FAILURE,
    failureMessage,
  };
};

export const checkEventLookupIdSuccess = (successMessage) => {
  return {
    type: actions.EVENT_LOOKUPID_CHECK_SUCCESS,
    successMessage,
  };
};

export const storeEventLookupId = (eventLookupId) => {
  return {
    type: actions.STORE_EVENT_LOOKUP_ID,
    eventLookupId,
  };
};

export const loadTemplateBegin = () => {
  return {
    type: actions.LOAD_TEMPLATE_BEGIN,
  };
};

export const loadTemplateSuccess = (template, rdatFlag, isNewEvent) => {
  return {
    type: actions.LOAD_TEMPLATE_SUCCESS,
    template,
    rdatFlag,
    isNewEvent,
  };
};

export const loadTemplateFailure = (failureMessage) => {
  return {
    type: actions.LOAD_TEMPLATE_FAILURE,
    failureMessage,
  };
};

export const fetchTemplatesBegin = () => {
  return {
    type: actions.FETCH_TEMPLATES_BEGIN,
  };
};

export const fetchTemplateSuccess = (templates) => {
  return {
    type: actions.FETCH_TEMPLATES_SUCCESS,
    templates,
  };
};

export const fetchTemplatesFailure = () => {
  return {
    type: actions.FETCH_TEMPLATES_FAILURE,
  };
};

export const fetchVenueMapsBegin = () => {
  return {
    type: actions.FETCH_VENUE_MAPS_BEGIN,
  };
};

export const fetchVenueMapsSuccess = (venueMaps) => {
  return {
    type: actions.FETCH_VENUE_MAPS_SUCCESS,
    venueMaps,
  };
};

export const fetchVenueMapsFailure = (failureMessage) => {
  return {
    type: actions.FETCH_VENUE_MAPS_FAILURE,
    failureMessage,
  };
};

export const loadCreateEventDetailsBegin = () => {
  return { type: actions.LOAD_CREATE_EVENT_DETAILS_BEGIN };
};

export const loadCreateEventDetailsSuccess = (event, flag) => {
  return { type: actions.LOAD_CREATE_EVENT_DETAILS_SUCCESS, event, flag };
};

export const loadCreateEventDetailsFailure = () => {
  return { type: actions.LOAD_CREATE_EVENT_DETAILS_FAILURE };
};

export const deleteMedia = (mediaId) => {
  return {
    type: actions.DELETE_MEDIA,
    mediaId,
  };
};

export const getSitesBegin = () => {
  return { type: actions.GET_SITES_BEGIN };
};

export const getSitesSuccess = (sites, isNewEvent) => {
  return { type: actions.GET_SITES_SUCCESS, sites, isNewEvent };
};

export const getSitesFailure = () => {
  return { type: actions.GET_SITES_FAILURE };
};

export const fetchEmailTemplatesBegin = () => {
  return { type: actions.FETCH_EMAIL_TEMPLATES_BEGIN };
};

export const fetchEmailTemplatesSuccess = (data) => {
  return {
    type: actions.FETCH_EMAIL_TEMPLATES_SUCCESS,
    emailTemplates: data.emailTemplates,
  };
};

export const fetchEmailTemplatesFailure = (error) => {
  return { type: actions.FETCH_EMAIL_TEMPLATES_FAILURE, error };
};

export const fetchTaxProfileBegin = () => {
  return { type: actions.FETCH_TAX_PROFILE_BEGIN };
};

export const fetchTaxPofileSuccess = (data) => {
  return {
    type: actions.FETCH_TAX_PROFILE_SUCCESS,
    taxProfiles: data.taxProfiles,
  };
};

export const fetchTaxProfileFailure = (error) => {
  return { type: actions.FETCH_TAX_PROFILE_FAILURE, error };
};

export const directToEventDetails = (eventId) => {
  browserHistory.push(`/events/${eventId}`);
  return {
    type: actions.DIRECT_TO_EVENT_DETAILS,
  };
};

export const createInitialTimeValues = (startDate, endDate) => {
  return {
    type: actions.CREATE_INITIAL_TIME_VALUES,
    startDate,
    endDate,
  };
};

export const generateInitialTimeValues = () => {
  return (dispatch) => {
    const startDate = moment().format('YYYY-MM-DDTHH:00:00');
    const endDate = moment().format('YYYY-MM-DDTHH:00:00');
    dispatch(createInitialTimeValues(startDate, endDate));
  };
};

export const resetEvent = () => {
  return {
    type: actions.RESET_EVENT,
  };
};
export const calculateRelativeDates = (fieldId, dateObject) => {
  return {
    type: CALCULATE_RELATIVE_DATES,
    fieldId,
    dateObject,
  };
};

export const eventStartDateChange = (fieldId, date) => {
  return (dispatch) => {
    dispatch(handleEventStartDateSave(date));
    dispatch(calculateRelativeDates(fieldId, date));
  };
};

export const onsaleDateSave = (fieldId, date) => {
  return (dispatch) => {
    dispatch(handleOnsaleDateSave({ fieldId, date }));
    dispatch(calculateRelativeDates(fieldId, date));
  };
};

export const removePriceCodeFromEvent = (zoneId, priceCodeId) => {
  return {
    type: actions.REMOVE_PRICE_CODE_FROM_EVENT,
    zoneId,
    priceCodeId,
  };
};

export const addPriceCodesToEvent = (zoneId, newPriceCodes) => {
  return {
    type: actions.ADD_PRICE_CODES_TO_EVENT,
    zoneId,
    newPriceCodes,
  };
};

export const setHasModifiedOffers = (setting) => {
  return { type: actions.SET_HAS_MODIFIED_OFFERS, setting };
};

//////////////////
//User Input Actions
///////////////////

export const handleOnsaleDateSave = (data) => {
  return {
    type: actions.HANDLE_ON_SALE_DATE_SAVE,
    data,
  };
};

export const handleEventStartDateSave = (date) => {
  return {
    type: actions.HANDLE_EVENT_START_DATE_SAVE,
    date,
  };
};
export const handleEventEndDateSave = (data) => {
  return {
    type: actions.HANDLE_EVENT_END_DATE_SAVE,
    data,
  };
};
export const handleETicketDateSave = (data) => {
  return {
    type: actions.HANDLE_ETICKET_DATE_SAVE,
    data,
  };
};
export const handleFlashDateSave = (data) => {
  return {
    type: actions.HANDLE_FLASH_DATE_SAVE,
    data,
  };
};
export const handleStandardDeliveryDateSave = (data) => {
  return {
    type: actions.HANDLE_STANDARD_DELIVERY_DATE_SAVE,
    data,
  };
};
export const handleAnnouncementDateSave = (data) => {
  return {
    type: actions.HANDLE_ANNOUNCEMENT_DATE_SAVE,
    data,
  };
};

export const handleExpirationDateSave = (data) => {
  return {
    type: actions.HANDLE_EXPIRATION_DATE_SAVE,
    data,
  };
};

export const handleExpirationDateReset = () => {
  return {
    type: actions.HANDLE_EXPIRATION_DATE_RESET,
  };
};

export const handleDoorDateSave = (date) => {
  return {
    type: actions.HANDLE_DOORS_DATE_SAVE,
    date,
  };
};

export const handleEventNameInput = (text) => {
  return {
    type: actions.HANDLE_EVENT_NAME_INPUT,
    text,
  };
};

export const handleSelectVenueMapFromDropdown = (venue) => {
  return {
    type: actions.HANDLE_SELECT_VENUE_MAP_FROM_DROPDOWN,
    venue,
  };
};

export const handleChangeCmsAge = (newAge) => {
  return {
    type: actions.HANDLE_CMS_AGE_CHANGE,
    newAge,
  };
};

export const handleChangeCmsStatus = (newStatus) => {
  return {
    type: actions.HANDLE_CMS_STATUS_CHANGE,
    newStatus,
  };
};

export const handleChangeCmsMajorCategory = (newMajorCategoryId, level) => {
  return {
    type: actions.HANDLE_CMS_MAJOR_CATEGORY_CHANGE,
    newMajorCategoryId,
    level,
  };
};

export const handleChangeCmsMinorCategory = (newMinorCategoryId, level) => {
  return {
    type: actions.HANDLE_CMS_MINOR_CATEGORY_CHANGE,
    newMinorCategoryId,
    level,
  };
};

export const handleChangeCmsPublishStatus = (newPublishStatus) => {
  return {
    type: actions.HANDLE_CMS_PUBLISH_STATUS_CHANGE,
    newPublishStatus,
  };
};

export const handleChangeCmsBio = (bioText) => {
  return {
    type: actions.HANDLE_CMS_BIO_CHANGE,
    bioText,
  };
};

export const handleChangeCmsDescription = (description) => {
  return {
    type: actions.HANDLE_CMS_DESCRIPTION_CHANGE,
    description,
  };
};

export const handleChangeEdpStatus = (status) => {
  return {
    type: actions.HANDLE_CMS_EDP_STATUS_CHANGE,
    status,
  };
};

export const handleEventLookupIdInput = (text) => {
  return {
    type: actions.HANDLE_EVENT_LOOKUP_ID_INPUT,
    text,
  };
};

export const handlePriceLevelOverrideInManifest = (value) => {
  return {
    type: actions.HANDLE_PRICE_LEVEL_OVERRIDE_IN_MANIFEST,
    value,
  };
};

export const handleSiteVisibility = (label) => {
  return {
    type: actions.HANDLE_SITE_VISIBILITY,
    label,
  };
};

export const handlePresentedBy = (data) => {
  return {
    type: actions.HANDLE_PRESENTED_BY,
    data,
  };
};

export const handleTour = (data) => {
  return {
    type: actions.HANDLE_TOUR,
    data,
  };
};

export const handleDoorPrice = (data) => {
  return {
    type: actions.HANDLE_DOOR_PRICE,
    data,
  };
};

export const handleTicketPrice = (data) => {
  return {
    type: actions.HANDLE_TICKET_PRICE,
    data,
  };
};

export const publishEventBegin = () => {
  return { type: actions.PUBLISH_EVENT_BEGIN };
};

export const publishEventSuccess = (eventId) => {
  return { type: actions.PUBLISH_EVENT_SUCCESS, eventId };
};

export const publishEventFailure = (failureMessage) => {
  return { type: actions.PUBLISH_EVENT_FAILURE, failureMessage };
};

export const publishPortalEventBegin = () => {
  return { type: actions.PUBLISH_PORTAL_EVENT_BEGIN };
};

export const publishPortalEventSuccess = (eventId) => {
  return { type: actions.PUBLISH_PORTAL_EVENT_SUCCESS, eventId };
};

export const publishPortalEventFailure = (failureMessage) => {
  return { type: actions.PUBLISH_PORTAL_EVENT_FAILURE, failureMessage };
};

export const createCMSEventBegin = () => {
  return { type: actions.CREATE_CMS_EVENT_BEGIN };
};

export const createCMSEventSuccess = (eventId) => {
  return { type: actions.CREATE_CMS_EVENT_SUCCESS, eventId };
};

export const createCMSEventFailure = (failureMessage) => {
  return { type: actions.CREATE_CMS_EVENT_FAILURE, failureMessage };
};

export const updateEventBegin = () => {
  return { type: actions.UPDATE_EVENT_BEGIN };
};

export const updateEventSuccess = (eventId) => {
  return { type: actions.UPDATE_EVENT_SUCCESS, eventId };
};

export const updateEventFailure = (failureMessage) => {
  return { type: actions.UPDATE_EVENT_FAILURE, failureMessage };
};

export const checkForEventOverlapBegin = () => {
  return { type: actions.CHECK_FOR_EVENT_OVERLAP_BEGIN };
};

export const checkForEventOverlapSuccess = (events) => {
  return { type: actions.CHECK_FOR_EVENT_OVERLAP_SUCCESS, events };
};

export const checkForEventOverlapFailure = () => {
  return { type: actions.CHECK_FOR_EVENT_OVERLAP_FAILURE };
};

export const searchTagsBegin = () => {
  return { type: actions.SEARCH_TAGS_BEGIN };
};

export const searchTagsFailure = (err) => {
  return { type: actions.SEARCH_TAGS_FAILURE, err };
};

export const searchPromotersBegin = () => {
  return { type: actions.SEARCH_PROMOTERS_BEGIN };
};

export const searchPromotersSuccess = (promoters, promoterName) => {
  return { type: actions.SEARCH_PROMOTERS_SUCCESS, promoters, promoterName };
};

export const autoCompleteArtistsResponse = (data, artistName, key) => {
  return {
    type: actions.AUTO_COMPLETE_ARTISTS_RESPONSE,
    data,
    artistName,
    key,
  };
};

export const handleRemoveTag = (tag, key) => {
  return { type: actions.REMOVE_TAG, tag, key };
};

export const addTag = (tag, key) => {
  return { type: actions.ADD_TAG, tag, key };
};

export const searchPromotersFailure = () => {
  return {
    type: actions.SEARCH_PROMOTERS_FAILURE,
    errorMessage: 'Error searching promoters',
  };
};

export const addPromoter = (promoter) => {
  return { type: actions.ADD_PROMOTER, promoter };
};

export const removePromoter = (promoter) => {
  return { type: actions.REMOVE_PROMOTER, promoter };
};

export const handleLookupId = (text) => {
  return {
    type: actions.HANDLE_LOOKUP_ID_INPUT,
    text,
  };
};

export const clearLastSavedOffer = () => {
  const offerId = 0;
  return {
    type: actions.SET_LAST_SAVED_OFFER,
    offerId,
  };
};

export const handleOriginalTemplateId = (templateId, templateName) => {
  return {
    type: actions.HANDLE_ORIGINAL_TEMPLATE_ID,
    templateId,
    templateName,
  };
};

export const getPaymentMethodsBegin = () => {
  return {
    type: actions.GET_PAYMENT_METHODS_BEGIN,
  };
};
export const getPaymentMethodsSuccess = (paymentMethods) => {
  return {
    type: actions.GET_PAYMENT_METHODS_SUCCESS,
    paymentMethods,
  };
};
export const getPaymentMethodsFailure = (failureMessage) => {
  return {
    type: actions.GET_PAYMENT_METHODS_FAILURE,
    failureMessage,
  };
};
export const getStatusCodesBegin = () => {
  return {
    type: actions.GET_STATUS_CODES_BEGIN,
  };
};
export const getPriceLevelsSuccess = (priceLevels) => {
  return {
    type: actions.GET_PRICE_LEVELS_SUCCESS,
    priceLevels,
  };
};
export const getStatusCodesFailure = (failureMessage) => {
  return {
    type: actions.GET_STATUS_CODES_FAILURE,
    failureMessage,
  };
};

export const getStatusCodesSuccess = (statusCodes) => {
  return {
    type: actions.GET_STATUS_CODES_SUCCESS,
    statusCodes,
  };
};

export const resetOfferTemplateId = () => {
  return {
    type: actions.RESET_OFFER_TEMPLATE_ID,
  };
};

export const removeTemplateOffer = () => {
  return {
    type: actions.REMOVE_TEMPLATE_OFFER,
  };
};

export const getOffer = (offer, zoneId) => {
  return {
    type: actions.GET_OFFER,
    offer,
    zoneId,
  };
};
export const clearTemplateOffers = () => {
  return { type: actions.CLEAR_TEMPLATE_OFFERS };
};

export const clearBaseTemplate = () => {
  return { type: actions.CLEAR_BASE_TEMPLATE };
};

export const clearTemplateBaseEventData = () => {
  return { type: actions.CLEAR_TEMPLATE_BASE_EVENT_DATA };
};

export const flagOfferIsIncomplete = () => {
  return {
    type: actions.FLAG_OFFER_IS_INCOMPLETE,
  };
};
export const storeOfferTemplateId = (uniqueId) => {
  return { type: actions.STORE_OFFER_TEMPLATE_ID, uniqueId };
};

export const generateEventLookupId = (id) => {
  return {
    type: actions.GENERATE_NEW_OFFER_LOOKUP_ID,
    id,
  };
};

export const updateOffer = (offer) => {
  return {
    type: actions.UPDATE_OFFER,
    offer,
  };
};

export const clearEvent = () => {
  return {
    type: actions.CLEAR_EVENT,
  };
};
export const loadEventDetails = (eventId, rules, portalId) => {
  return { type: actions.LOAD_EVENT_DETAILS, eventId, rules, portalId };
};
export const loadEventDetailsBegin = () => {
  return { type: actions.LOAD_EVENT_DETAILS_BEGIN };
};
export const loadEventDetailsSuccess = (event, flag, promoterFlag) => {
  return {
    type: actions.LOAD_EVENT_DETAILS_SUCCESS,
    event,
    flag,
  };
};
export const loadEventDetailsFailure = (err) => {
  return { type: actions.LOAD_EVENT_DETAILS_FAILURE, err };
};
export const loadEventDetailsAbort = () => {
  return { type: actions.LOAD_EVENT_DETAILS_ABORT };
};

export const getOfferById = (offerId, rules) => {
  return { type: actions.GET_OFFER_BY_ID, offerId, rules };
};

export const handleEventTemplateChange = (templateId) => {
  return { type: actions.HANDLE_EVENT_TEMPLATE_CHANGE, templateId };
};

export const getOfferByIdFailure = (failureMessage) => {
  return {
    type: actions.GET_OFFER_BY_ID_FAILURE,
    failureMessage,
  };
};
export const getOfferByIdSuccess = (
  offer,
  eventName,
  zone,
  flag,
  offerLabels,
  featuredOffers,
  isOfferPriceLevelOnSaleOffSaleDatesEnabled
) => {
  return {
    type: actions.GET_OFFER_BY_ID_SUCCESS,
    offer,
    eventName,
    zone,
    flag,
    offerLabels,
    featuredOffers,
    isOfferPriceLevelOnSaleOffSaleDatesEnabled,
  };
};

export const toggleAccessControl = (zoneId) => {
  return {
    type: actions.TOGGLE_ACCESS_CONTROL,
    zoneId,
  };
};

export const setOnsaleDate = (date) => {
  return { type: actions.SET_ONSALE_DATE, date };
};

export const setGeneralOnsaleDate = (date) => {
  return { type: actions.SET_GENERAL_ONSALE_DATE, date };
};

export const saveZoneBegin = (data) => {
  return { type: actions.SAVE_ZONE_BEGIN, data };
};

export const saveZoneFailure = (err) => {
  return { type: actions.SAVE_ZONE_FAILURE, err };
};

export const saveZoneSuccess = (data) => {
  return { type: actions.SAVE_ZONE_SUCCESS, data };
};

export const cancelZoneSettings = (eventId, zoneId) => {
  redirectToPath(`/event/${eventId}/zones/${zoneId}`);
  return {
    type: actions.CANCEL_ZONE_SETTINGS,
    eventId,
    zoneId,
  };
};

export const saveFlashSeatBegin = () => {
  return { type: actions.SAVE_FLASHSEAT_BEGIN };
};

export const saveFlashSeatFailure = (err) => {
  return { type: actions.SAVE_FLASHSEAT_FAILURE, err };
};

export const saveFlashSeatSuccess = (data) => {
  return { type: actions.SAVE_FLASHSEAT_SUCCESS, data };
};

export const cancelFlashSeatSettings = (eventId, zoneId) => {
  redirectToPath(`/event/${eventId}/zones/${zoneId}`);
  return {
    type: actions.CANCEL_FLASHSEAT_SETTINGS,
    eventId,
    zoneId,
  };
};

export const loadTemplateBaseEventDataBegin = () => {
  return {
    type: actions.LOAD_TEMPLATE_BASE_EVENT_DATA_BEGIN,
  };
};

export const loadTemplateBaseEventDataSuccess = (
  templateBaseEventData,
  axsEvent,
  rdatFlag
) => {
  // needs event.axsEvent, gotta call getState
  return {
    type: actions.LOAD_TEMPLATE_BASE_EVENT_DATA_SUCCESS,
    templateBaseEventData,
    axsEvent,
    rdatFlag,
  };
};

export const loadPortalTemplateBaseEventDataSuccess = (
  templateBaseEventData,
  axsEvent,
  rdatFlag
) => {
  return {
    type: actions.LOAD_PORTAL_TEMPLATE_BASE_EVENT_DATA_SUCCESS,
    templateBaseEventData,
    axsEvent,
    rdatFlag,
  };
};

export const loadTemplateBaseEventDataFailure = (failureMessage) => {
  return {
    type: actions.LOAD_TEMPLATE_BASE_EVENT_DATA_FAILURE,
    failureMessage,
  };
};

export const loadTemplateBaseBegin = () => {
  return {
    type: actions.LOAD_TEMPLATE_BASE_BEGIN,
  };
};

export const loadTemplateBaseSuccess = (template) => {
  return {
    type: actions.LOAD_TEMPLATE_BASE_SUCCESS,
    template,
  };
};

export const loadTemplateBaseFailure = (failureMessage) => {
  return {
    type: actions.LOAD_TEMPLATE_BASE_FAILURE,
    failureMessage,
  };
};

export const loadPortalTemplateBaseBegin = () => {
  return {
    type: actions.LOAD_PORTAL_TEMPLATE_BASE_BEGIN,
  };
};

export const loadPortalTemplateBaseSuccess = (template) => {
  return {
    type: actions.LOAD_PORTAL_TEMPLATE_BASE_SUCCESS,
    template,
  };
};

export const loadPortalTemplateBaseFailure = (failureMessage) => {
  return {
    type: actions.LOAD_PORTAL_TEMPLATE_BASE_FAILURE,
    failureMessage,
  };
};

export const addTemplateOffersToEDP = (offers) => {
  return {
    type: actions.ADD_TEMPLATE_OFFERS_TO_EDP,
    offers,
  };
};

export const autoPublishBegin = (offers) => {
  return {
    type: actions.AUTO_PUBLISH_OFFERS_BEGIN,
    offers,
  };
};

export const autoPublishSuccess = (offers) => {
  return {
    type: actions.AUTO_PUBLISH_OFFERS_SUCCESS,
    offers,
  };
};

export const autoPublishFailure = (failureMessage) => {
  return {
    type: actions.AUTO_PUBLISH_OFFERS_FAILURE,
    failureMessage,
  };
};

export const saveOriginalTemplateIdBegin = () => {
  return { type: actions.SAVE_ORIGINAL_TEMPLATE_ID_BEGIN };
};

export const saveOriginalTemplateIdSuccess = () => {
  return { type: actions.SAVE_ORIGINAL_TEMPLATE_ID_SUCCESS };
};

export const saveOriginalTemplateIdFailure = (err) => {
  return { type: actions.SAVE_ORIGINAL_TEMPLATE_ID_FAILURE, err };
};

export const updateOriginalTemplateId = (originalTemplateId) => {
  return { type: actions.UPDATE_ORIGINAL_TEMPLATE_ID, originalTemplateId };
};

export const loadPortalEventDetails = (portalEvent) => {
  return { type: actions.LOAD_PORTAL_EVENT_DETAILS, portalEvent };
};

export const setTicketTextTemplate = (id, zoneId) => {
  return { type: actions.SET_TICKET_TEXT_TEMPLATE, id, zoneId };
};

export const loadTicketTextTemplatesBegin = () => {
  return { type: actions.LOAD_TICKET_TEXT_TEMPLATES_BEGIN };
};

export const loadTicketTextTemplatesSuccess = (templates) => {
  return { type: actions.LOAD_TICKET_TEXT_TEMPLATES_SUCCESS, templates };
};

export const loadTicketTextTemplatesFailure = (message) => {
  return { type: actions.LOAD_TICKET_TEXT_TEMPLATES_FAILURE, message };
};

export const setImage = (data) => {
  return { type: actions.SET_IMAGE, data };
};

export const setImageSquare = (data) => {
  return { type: actions.SET_IMAGE_SQUARE, data };
};

export const setImageFacebook = (data) => {
  return { type: actions.SET_IMAGE_FACEBOOK, data };
};

export const updateNotifications = (message, status, dismissable) => {
  return {
    type: UPDATE_NOTIFICATION,
    message,
    status,
    dismissable,
  };
};

export const loadCMSRevisionsBegin = () => {
  return { type: actions.LOAD_CMS_REVISIONS_BEGIN };
};

export const loadCMSRevisionsSuccess = (data) => {
  return { type: actions.LOAD_CMS_REVISIONS_SUCCESS, data };
};

export const loadCMSRevisionsFailure = (err) => {
  return { type: actions.LOAD_CMS_REVISIONS_FAILURE, err };
};

export const handleAxsManagerChange = (id) => {
  return { type: actions.HANDLE_AXS_MANAGER_CHANGE, id };
};
export const getAxsManagerOptionsBegin = () => {
  return { type: actions.GET_AXS_MANAGER_OPTIONS_BEGIN };
};
export const getAxsManagerOptionsFailure = (error) => {
  return { type: actions.GET_AXS_MANAGER_OPTIONS_FAILURE, error };
};
export const getAxsManagerOptionsSuccess = (axsManagerOptions) => {
  return { type: actions.GET_AXS_MANAGER_OPTIONS_SUCCESS, axsManagerOptions };
};

export const handleVenueManagerChange = (id) => {
  return { type: actions.HANDLE_VENUE_MANAGER_CHANGE, id };
};

export const handlePromoterChange = (id) => {
  return { type: HANDLE_PROMOTER_CHANGE, id };
};

export const handleShortCodesChange = (id) => {
  return { type: actions.HANDLE_SHORT_CODES_CHANGE, id };
};

export const getVenueManagerOptionsBegin = () => {
  return { type: actions.GET_VENUE_MANAGER_OPTIONS_BEGIN };
};
export const getVenueManagerOptionsFailure = (error) => {
  return { type: actions.GET_VENUE_MANAGER_OPTIONS_FAILURE, error };
};
export const getVenueManagerOptionsSuccess = (venueManagerOptions) => {
  return {
    type: actions.GET_VENUE_MANAGER_OPTIONS_SUCCESS,
    venueManagerOptions,
  };
};

export const selectEventTypeFromDropDown = (eventCategory) => {
  return { type: actions.SELECT_EVENT_TYPE_FROM_DROPDOWN, eventCategory };
};

export const selectSeasonTypeFromDropDown = (seasonCategory) => {
  return { type: actions.SELECT_SEASON_TYPE_FROM_DROPDOWN, seasonCategory };
};

export const setShortCodesFlag = (flag, value, isLoaded) => {
  return { type: actions.SET_SHORT_CODES_FLAG, flag, value, isLoaded };
};
export const setEventListing = (flag, value, isLoaded) => {
  return { type: actions.SET_LISTING_EXPIRATION_FLAG, flag, value, isLoaded };
};
export const fetchShortCodesBegin = () => {
  return { type: actions.FETCH_SHORT_CODES_BEGIN };
};
export const fetchShortCodesFailure = (error) => {
  return { type: actions.FETCH_SHORT_CODES_FAILURE, error };
};
export const fetchShortCodesSuccess = (shortCodes) => {
  return { type: actions.FETCH_SHORT_CODES_SUCCESS, shortCodes };
};

///////////////
/////Routing
///////////////
export const directToOffers = (eventId) => {
  // not sure if this is being used
  browserHistory.push('/event/' + eventId + '/offers');
  return { type: actions.DIRECT_TO_OFFERS };
};

export const redirectToEvents = (message) => {
  browserHistory.push('/events');
  return { type: actions.REDIRECT_TO_EVENTS, message };
};
export const directToEditOffer = (eventId, offerId) => {
  browserHistory.push(`/events/${eventId}/offer/${offerId}`);
  return { type: actions.DIRECT_TO_EDIT_OFFER };
};

export const directToCreateEditEvent = (eventId) => {
  browserHistory.push(`/event/${eventId}`);
  return { type: actions.DIRECT_TO_CREATE_EDIT_EVENT };
};

export const cancelAdmissions = (eventId) => {
  redirectToPath(`/events/${eventId}`);
  return {
    type: actions.CANCEL_ADMISSIONS,
    eventId,
  };
};

export const redirectToPath = (path) => {
  browserHistory.push(path);
  return {
    type: actions.REDIRECT_TO_PATH,
  };
};

export const directToAddOffers = (eventId) => {
  redirectToPath(`/events/${eventId}/addoffers`);
  return { type: actions.DIRECT_TO_ADD_OFFERS };
};

export const directToAddZones = (eventId, portalId) => {
  browserHistory.push(`/events/${eventId}/portal/${portalId}/addzone`);
  return { type: actions.DIRECT_TO_ADD_ZONES };
};

export const directToOfferSettings = (eventId) => {
  browserHistory.push(`/events/${eventId}/offers/settings`);
  return { type: actions.DIRECT_TO_OFFER_SETTINGS };
};

export const directToEDP = (eventId) => {
  browserHistory.push(`events/${eventId}`);
  return { type: actions.DIRECT_TO_EDP };
};

export const directToAdmissions = (eventId, zoneId) => {
  browserHistory.push(`/event/${eventId}/zones/${zoneId}`);
  return {
    type: actions.DIRECT_TO_ADMISSIONS,
  };
};

export const directToEventInformation = (id) => {
  browserHistory.push(`event/${id}`);
  return {
    type: actions.DIRECT_TO_EVENT_INFORMATION,
  };
};

export const directToEDPPortalEvent = (eventId, portalId) => {
  browserHistory.push(`/events/${eventId}/portal/${portalId}/`);
  return {
    type: actions.DIRECT_TO_EDP_PORTAL_EVENT,
  };
};

export const directToOfferDetails = (eventId, offerId) => {
  browserHistory.push(`/events/${eventId}/offer/${offerId}/details`);
  return {
    type: actions.DIRECT_TO_OFFER_DETAILS,
  };
};

////////////////
/////Async
///////////////

export const fetchShortCodes = () => {
  return (dispatch) => {
    dispatch(fetchShortCodesBegin());
    return getShortCodes()
      .then((response) => {
        if (!get(response, 'data.ResponseStatus.ErrorCode')) {
          const data = camelcaseKeysDeep(response.data);
          dispatch(fetchShortCodesSuccess(data.shortCodes));
        } else {
          throw { Message: get(response, 'data.ResponseStatus.Message') }; // eslint-disable-line no-throw-literal
        }
      })
      .catch((error) => {
        dispatch(
          setAndHideNotification(
            `Error fetching short codes: ${error}`,
            'error',
            4000
          )
        );
        dispatch(fetchShortCodesFailure(error));
      });
  };
};

export const fetchAxsManagers = () => {
  return (dispatch, getState) => {
    const contextId = getState().app.contextId;
    dispatch(getAxsManagerOptionsBegin());
    return getAxsManagers(contextId)
      .then((response) => {
        if (!get(response, 'data.ResponseStatus.ErrorCode')) {
          //TODO if contextId does not have access to Axs manager, update state accordingly
          const data = camelcaseKeysDeep(response.data);
          dispatch(getAxsManagerOptionsSuccess(data.axsManagers));
        } else {
          throw { Message: get(response, 'data.ResponseStatus.Message') }; // eslint-disable-line no-throw-literal
        }
      })
      .catch((error) => {
        dispatch(getAxsManagerOptionsFailure(error));
      });
  };
};

export const fetchVenueManagers = () => {
  return (dispatch, getState) => {
    const contextId = getState().app.contextId;
    dispatch(getVenueManagerOptionsBegin());
    return getVenueManagers(contextId)
      .then((response) => {
        if (!get(response, 'data.ResponseStatus.ErrorCode')) {
          //TODO if contextId does not have access to Venue manager, update state accordingly
          const data = camelcaseKeysDeep(response.data);
          dispatch(getVenueManagerOptionsSuccess(data.venueManagers));
        } else {
          throw { Message: get(response, 'data.ResponseStatus.Message') }; // eslint-disable-line no-throw-literal
        }
      })
      .catch((error) => {
        dispatch(getVenueManagerOptionsFailure(error));
      });
  };
};

export const createNewOfferLookupId = (eventLookupId, offerLookupId) => {
  return (dispatch) => {
    const offerSubId = offerLookupId.split('_');
    const newId = offerSubId
      ? eventLookupId + '_' + offerSubId.slice(1).join('_')
      : offerLookupId;
    dispatch(generateEventLookupId(newId));
  };
};

export const loadPromoterFlag = (flagKey) => {
  return (dispatch, getState) => {
    const state = getState();
    const contextId = state.app.contextId;
    getLDFlagValue(contextId, flagKey)
      .then((response) => {
        if (response && response.status === 200) {
          const {
            data: { IsEnabled },
          } = response;
          dispatch(setLDFlag(flagKey, IsEnabled, true));
        } else dispatch(setLDFlag(flagKey, false, false));
      })
      .catch((err) => {
        dispatch(setLDFlag(flagKey, false, false));
      });
  };
};

export const loadShortCodesFlag = (flagKey) => {
  return (dispatch, getState) => {
    const state = getState();
    const contextId = state.app.contextId;
    getLDFlagValue(contextId, flagKey)
      .then((response) => {
        if (response && response.status === 200) {
          const {
            data: { IsEnabled },
          } = response;
          dispatch(setShortCodesFlag(flagKey, IsEnabled, true));
        } else dispatch(setShortCodesFlag(flagKey, false, false));
      })
      .catch((err) => {
        dispatch(setShortCodesFlag(flagKey, false, false));
      });
  };
};

export const loadListingExpirationFlag = (flagKey) => {
  return (dispatch, getState) => {
    const state = getState();
    const contextId = state.app.contextId;
    getLDFlagValue(contextId, flagKey)
      .then((response) => {
        if (response && response.status === 200) {
          const {
            data: { IsEnabled },
          } = response;
          dispatch(setEventListing(flagKey, IsEnabled, true));
        } else dispatch(setEventListing(flagKey, false, false));
      })
      .catch((err) => {
        dispatch(setEventListing(flagKey, false, false));
      });
  };
};

export const saveAutoPublishOffers = (offers, parentEventHasCMS) => {
  return (dispatch, getState) => {
    dispatch(autoPublishBegin(offers));
    const state = getState();
    const contextId = state.app.contextId;
    const eventId = state.event_details.event.id;
    const venueId = state.event_details.event.venueId;
    const userName = state.app.UserName;
    const AXSEvent = parentEventHasCMS
      ? { EventId: parentEventHasCMS.eventId }
      : null;
    saveAutoPublishOffer(
      contextId,
      AXSEvent,
      venueId,
      eventId,
      offers,
      userName
    )
      .then((response) => {
        const responseStatus =
          (response && response.data && response.data.ResponseStatus) || {};
        const success =
          responseStatus.Message === 'Success' &&
          response &&
          response.data &&
          response.data.OfferIds.length > 0 &&
          (!responseStatus.Warnings || !responseStatus.Warnings.length);
        const successWithWarning =
          responseStatus.Message === 'Success' &&
          response &&
          response.data &&
          response.data.OfferIds.length > 0 &&
          responseStatus.Warnings &&
          responseStatus.Warnings.length;

        if (success) {
          dispatch(
            setAndHideNotification(
              `Offers have been published successfully `,
              'success',
              4000
            )
          );
          dispatch(autoPublishSuccess(offers));
        } else if (successWithWarning) {
          dispatch(
            setAndHideNotification(
              'WARNING: Offer dates configuration problem. Please check offer, price level, or price code dates.',
              'warning',
              15000
            )
          );
          dispatch(autoPublishSuccess(offers));
        } else {
          dispatch(autoPublishFailure(response.data.ResponseStatus.Message));
          dispatch(
            setAndHideNotification(
              response.data.ResponseStatus.Message,
              'error',
              6000
            )
          );
        }
        dispatch(directToEventDetails(eventId));
      })
      .catch((err) => {
        dispatch(autoPublishFailure(err));
        dispatch(
          setAndHideNotification(
            'An error occurred while saving auto publish setting offers.',
            'error',
            6000
          )
        );
        dispatch(directToEventDetails(eventId));
      });
  };
};

export const selectOffer = (eventId, offerId, zoneId) => {
  //TODO : I don't think this is being used ^
  return (dispatch, getState) => {
    const allOffers = getState().event_details.availEventOffers;
    const foundOffer = allOffers.filter((offer) => offer.id === offerId);
    dispatch(getOffer(foundOffer, zoneId));
    dispatch(directToEditOffer(eventId, offerId));
  };
};

/**
 * Loads all templates for a context using the Services API.
 *
 * @return {function(*, *): *}
 */
export const fetchUserTemplates = () => {
  return (dispatch, getState) => {
    dispatch(fetchTemplatesBegin());
    const contextId = getState().app.contextId;
    const userName = getState().app.userName;
    const loggerDetails = { contextId, payload: {}, userName };
    return getTemplates(contextId)
      .then((response) => {
        const success =
          response.data.Templates && response.data.Templates.length > 0;
        if (success) {
          const templates = camelcaseKeysDeep(response.data.Templates);
          dispatch(fetchTemplateSuccess(templates));
        } else {
          if (response.data.Templates && response.data.Templates.length === 0) {
            dispatch(
              updateNotifications(
                'No templates exist for this context.',
                'warning',
                true
              )
            );
          } else {
            Logger(
              response,
              loggerDetails,
              selectFeatureFlag(flags.LOGGER)(getState())
            );
            dispatch(
              updateNotifications(
                'Failed to fetch any templates.',
                'error',
                true
              )
            );
            dispatch(fetchTemplatesFailure('Failed to fetch templates.'));
          }
        }
      })
      .catch((err) => {
        Logger(
          null,
          loggerDetails,
          selectFeatureFlag(flags.LOGGER)(getState())
        );
        dispatch(
          updateNotifications('Failed to fetch any templates.', 'error', true)
        );
        dispatch(fetchTemplatesFailure(err.message));
      });
  };
};

/**
 * Associates an event with a template using the Services API.
 *
 * @param templateId
 * @param eventId
 * @return {function(*, *): *}
 */
export const saveOriginalTemplateId = (templateId, eventId) => {
  return (dispatch, getState) => {
    dispatch(saveOriginalTemplateIdBegin());
    const contextId = getState().app.contextId;
    const userName = getState().app.userName;
    const loggerDetails = {
      contextId,
      payload: { templateId: templateId, eventId: eventId },
      userName,
    };
    return saveOriginalTemplate(contextId, templateId, eventId)
      .then((response) => {
        const responseStatus =
          (response && response.data && response.data.ResponseStatus) || {};
        if (responseStatus.Message === 'Success') {
          dispatch(saveOriginalTemplateIdSuccess());
          dispatch(updateOriginalTemplateId(templateId));
          Logger(
            response,
            loggerDetails,
            selectFeatureFlag(flags.LOGGER)(getState())
          );
        } else {
          Logger(
            null,
            loggerDetails,
            selectFeatureFlag(flags.LOGGER)(getState())
          );
          dispatch(
            updateNotifications(
              "An error has occurred updating the event's template ID.",
              'error',
              true
            )
          );
          dispatch(
            saveOriginalTemplateIdFailure(
              'Failed to associate template for event.'
            )
          );
        }
      })
      .catch((err) => {
        dispatch(
          updateNotifications(
            "An error has occurred updating the event's template ID.",
            'error',
            true
          )
        );
        dispatch(saveOriginalTemplateIdFailure(err));
        Logger(
          null,
          loggerDetails,
          selectFeatureFlag(flags.LOGGER)(getState())
        );
      });
  };
};

/**
 * Load a template (get) using the Services API.
 *
 * @param templateId
 * @param isNewEvent
 * @return {function(*, *): *}
 */
export const loadTemplate = (templateId, isNewEvent) => {
  return (dispatch, getState) => {
    const contextId = getState().app.contextId;
    const userName = getState().app.userName;
    const rdatFlag = selectFeatureFlag(flags.RELATIVE_DATES_FE)(getState());
    const loggerDetails = { contextId, payload: {}, userName };

    dispatch(loadTemplateBegin());
    return getTemplate(contextId, templateId)
      .then((response) => {
        const responseStatus =
          (response && response.data && response.data.ResponseStatus) || {};
        if (responseStatus.Message === 'Success') {
          const foundTemplate = Object.assign({}, response.data.Templates[0]);
          const formatTemplate = camelcaseKeysDeep(foundTemplate);
          if (formatTemplate.hasOwnProperty('aXSVenueId')) {
            formatTemplate.axsVenueId = formatTemplate.aXSVenueId;
            // sync property spelling on template venue id
            delete formatTemplate.aXSVenueId;
          }
          dispatch(loadTemplateSuccess(formatTemplate, rdatFlag, isNewEvent));
        } else {
          Logger(
            response,
            loggerDetails,
            selectFeatureFlag(flags.LOGGER)(getState())
          );
          dispatch(updateNotification(responseStatus.Message, 'error', true));
        }
      })
      .catch((err) => {
        Logger(
          null,
          loggerDetails,
          selectFeatureFlag(flags.LOGGER)(getState())
        );
        dispatch(updateNotification('Failed to load template.', 'error', true));
        dispatch(loadTemplateFailure(err));
      });
  };
};

/**
 * Loads (get) the venue maps using the Services API.
 *
 * @return {function(*, *): *}
 */
export const fetchVenueMaps = () => {
  return (dispatch, getState) => {
    const contextId = getState().app.contextId;
    dispatch(fetchVenueMapsBegin());
    return getVenueMaps(contextId)
      .then((response) => {
        if (response.status === 200) {
          dispatch(fetchVenueMapsSuccess(response.data));
        }
      })
      .catch((err) => {
        dispatch(fetchVenueMapsFailure(err));
      });
  };
};

/**
 * Loads (get) an event from the Services api.
 *
 * @param eventId
 * @param {boolean} [isRedirectRequired]
 * @return {Function}
 */
export const loadCreateEventDetails = (eventId, isRedirectRequired = true) => {
  return (dispatch, getState) => {
    dispatch(loadCreateEventDetailsBegin());
    const contextId = getState().app.contextId;
    const userName = getState().app.userName;
    const loggerDetails = { contextId, payload: {}, userName };
    const rdatFlag = selectFeatureFlag(flags.RELATIVE_DATES_FE)(getState());
    getEvent(contextId, eventId)
      .then((response) => {
        if (response.data.hasOwnProperty('Event')) {
          const foundEvent = cloneDeep(response.data.Event);
          const formatEvent = camelcaseKeysDeep(foundEvent);
          isRedirectRequired && dispatch(directToCreateEditEvent(eventId));
          dispatch(loadCreateEventDetailsSuccess(formatEvent, rdatFlag));
        } else {
          Logger(
            response,
            loggerDetails,
            selectFeatureFlag(flags.LOGGER)(getState())
          );
          dispatch(
            loadCreateEventDetailsFailure(response.data.responseStatus.Message)
          );
          dispatch(updateNotification('Unable to load event.', 'error', true));
        }
      })
      .catch((err) => {
        Logger(
          null,
          loggerDetails,
          selectFeatureFlag(flags.LOGGER)(getState())
        );
        dispatch(loadCreateEventDetailsFailure(err));
        dispatch(updateNotification('Unable to load event.', 'error', true));
      });
  };
};

/**
 * Creates (post) a new event using the Services API.
 *
 * @param data
 * @return {Function}
 */
export const createEvent = (data) => {
  return async (dispatch, getState) => {
    dispatch(publishEventBegin());
    const contextId = getState().app.contextId;
    const userName = getState().app.UserName;
    const eventObj = Object.assign({}, data, {
      ContextId: contextId,
      UserName: userName,
    });
    const loggerDetails = { contextId, payload: data, userName };
    try {
      const response = await publishEvent(eventObj);

      const responseStatus =
        (response && response.data && response.data.ResponseStatus) || {};
      const success = responseStatus.Message === 'Success';

      if (success) {
        const eventId = response.data.EventId;
        dispatch(directToEventDetails(eventId));
        dispatch(publishEventSuccess(eventId));
        dispatch(
          updateNotification('The event has been published.', 'success')
        );
        if (
          response.data.Message &&
          response.data.Message.substr(1) === 'Duplicate Event'
        ) {
          dispatch(createCMSEventFailure(response.data.Message));
          dispatch(
            updateNotification(
              'Error creating CMS event. The server returned :  Failure - Could not save Cms Event Reason:' +
                response.data.Message,
              'error'
            )
          );
        }
      } else {
        Logger(
          response,
          loggerDetails,
          selectFeatureFlag(flags.LOGGER)(getState())
        );
        dispatch(updateNotification(`Unable to publish event.`, 'error', true));
        dispatch(publishEventFailure(responseStatus.Message));
        dispatch(toggleIsSaving(false));
      }
    } catch (error) {
      const { response, message } = error;
      const notification =
        response &&
        response.data.ResponseStatus &&
        response.data.ResponseStatus.TelemetryStackTraceId
          ? `Unable to publish event. reference ID: ${response.data.ResponseStatus.TelemetryStackTraceId}`
          : `Unable to publish event.`;

      Logger(
        response,
        loggerDetails,
        selectFeatureFlag(flags.LOGGER)(getState())
      );
      logoutAndRedirect(error);
      dispatch(updateNotification(`${notification}`, 'error', true));
      dispatch(publishEventFailure(message));
      dispatch(toggleIsSaving(false));
    }
  };
};

/**
 * Updates (put) an existing event through the Services API.
 *
 * @param data - Payload requires at minimum `Id`, `VenueId`, and `ContextId`,
 * @param redirectToEDP -
 * @return {function(*, *): *}
 */
// Need to sync with createCMSEvent
export const updateEvent = (data, redirectToEDP) => {
  return (dispatch, getState) => {
    dispatch(updateEventBegin());
    const contextId = getState().app.contextId;
    const userName = getState().app.UserName;
    const eventObj = Object.assign({}, data, {
      ContextId: contextId,
      UserName: userName,
    });
    const loggerDetails = { contextId, payload: data, userName };

    return saveEvent(eventObj)
      .then((response) => {
        const responseStatus =
          (response && response.data && response.data.ResponseStatus) || {};
        const success =
          responseStatus.Message === 'Success' &&
          !responseStatus.Warnings.length;
        const successWithWarning =
          responseStatus.Message === 'Success' &&
          responseStatus.Warnings &&
          responseStatus.Warnings.length;

        if (success) {
          if (redirectToEDP) dispatch(directToEDP(data.Id));
          dispatch(updateEventSuccess());
          dispatch(
            updateNotification('The event has been updated.', 'success')
          );
        } else if (successWithWarning) {
          if (redirectToEDP) dispatch(directToEDP(data.Id));
          dispatch(updateEventSuccess());
          dispatch(
            updateNotification(
              'WARNING: Offer dates configuration problem. Please check offer, price level, or price code dates.',
              'warning'
            )
          );
        } else if (responseStatus.ErrorCode === '409') {
          dispatch(setDataModifiedWarning(true));
          dispatch(toggleIsSaving(false));
        } else {
          Logger(
            response,
            loggerDetails,
            selectFeatureFlag(flags.LOGGER)(getState())
          );
          dispatch(updateEventFailure(response.data.ResponseStatus.Message));
          dispatch(
            updateNotification('Unable to update the event.', 'error', true)
          );
          dispatch(toggleIsSaving(false));
        }
      })
      .catch((err) => {
        dispatch(updateEventFailure(err));
        Logger(
          null,
          loggerDetails,
          selectFeatureFlag(flags.LOGGER)(getState())
        );
        dispatch(
          updateNotification('Unable to update the event.', 'error', true)
        );
        dispatch(toggleIsSaving(false));
      });
  };
};

export const checkForEventOverlap = (venueId, startDate) => {
  return (dispatch, getState) => {
    dispatch(checkForEventOverlapBegin());
    return getCheckForEventOverlap(venueId, startDate, getState().app.contextId)
      .then((response) => {
        const noError = response.data.hasOwnProperty('Events');
        if (noError) {
          const foundEvents = cloneDeep(response.data.Events);
          dispatch(checkForEventOverlapSuccess(camelcaseKeysDeep(foundEvents)));
        } else {
          dispatch(
            updateNotification(
              'Unable to verify if an event already exists for that date.',
              'error'
            )
          );
        }
      })
      .catch((err) => {
        dispatch(checkForEventOverlapFailure(err));
        dispatch(
          updateNotification(
            'Unable to verify if an event already exists for that date.',
            'error'
          )
        );
      });
  };
};

export const autoCompletePromoters = (promoterName) => {
  return (dispatch) => {
    dispatch(searchPromotersBegin());
    return searchPromoters(promoterName)
      .then((response) => {
        if (response.status === 200) {
          dispatch(searchPromotersSuccess(response.data, promoterName));
        }
      })
      .catch((err) => {
        dispatch(searchPromotersFailure(err));
        dispatch(
          updateNotification(
            'Unable to access the Promoter search. The server returned: ' + err,
            'error'
          )
        );
      });
  };
};

export const autoCompleteArtists = (artistName, key) => {
  return (dispatch) => {
    dispatch(searchTagsBegin());
    return searchArtists(artistName)
      .then((response) => {
        if (response.status === 200) {
          dispatch(autoCompleteArtistsResponse(response.data, artistName, key));
        }
      })
      .catch((err) => {
        dispatch(searchTagsFailure(err));
        dispatch(
          updateNotification(
            'Unable to access the Headliner search. The server returned: ' +
              err,
            'error'
          )
        );
      });
  };
};

export const runEventLookupIdCheck = () => {
  return (dispatch, getState) => {
    const contextId = getState().app.contextId;
    const lookupId = getState().event_details.eventCreation.eventLookupId;
    dispatch(checkEventLookupIdBegin());
    checkEventLookupId(contextId, lookupId)
      .then((response) => {
        const exists = response.data.Exists;
        if (!exists) {
          dispatch(checkEventLookupIdSuccess());
        } else {
          dispatch(checkEventLookupIdFailure(response));
        }
      })
      .catch((err) => {
        dispatch(checkEventLookupIdFailure(err));
      });
  };
};

export const createEventLookupId = (venueCode = '', startDate) => {
  const date = moment(
    startDate,
    dateFormats.TWELVE_HOUR_DATE_TIME_FORMAT
  ).format('YYMMDD');
  return (dispatch) => {
    const eventLookupId = venueCode.concat(date);
    dispatch(storeEventLookupId(eventLookupId));
    dispatch(runEventLookupIdCheck());
  };
};

export const validateEventLookupId = (lookupId) => {
  return (dispatch, getState) => {
    const contextId = getState().app.contextId;
    dispatch(checkEventLookupIdBegin());
    checkEventLookupId(contextId, lookupId)
      .then((response) => {
        const exists = response.data.Exists;
        if (!exists) {
          dispatch(checkEventLookupIdSuccess());
        } else {
          dispatch(checkEventLookupIdFailure(response));
        }
      })
      .catch((err) => {
        dispatch(checkEventLookupIdFailure(err));
      });
  };
};

/**
 * Converts a CMS-only event to an Event Tool/Back Office event using the Services API.
 *
 * @param data
 * @return {Function}
 */
export const createEventFromPortalEvent = (data) => {
  return (dispatch, getState) => {
    dispatch(publishPortalEventBegin());
    const contextId = getState().app.contextId;
    const userName = getState().app.UserName;
    const loggerDetails = { contextId, payload: data, userName };
    const eventObj = Object.assign({}, data, {
      ContextId: contextId,
      UserName: userName,
    });
    publishEvent(eventObj)
      .then((response) => {
        const responseStatus = response.data.ResponseStatus;
        if (responseStatus.Message === 'Success') {
          const eventId = response.data.EventId;
          dispatch(publishPortalEventSuccess());
          dispatch(clearEvent());
          dispatch(directToEDP(eventId));
          dispatch(updateNotifications('Event published.', 'success'));
          setTimeout(() => {
            dispatch({ type: 'HIDE_NOTIFICATION' });
          }, 8000);
        } else {
          Logger(
            response,
            loggerDetails,
            selectFeatureFlag(flags.LOGGER)(getState())
          );
          dispatch(publishPortalEventFailure(response.data));
          dispatch(
            updateNotification('Error adding zone to CMS event.', 'error', true)
          );
        }
      })
      .catch((err) => {
        Logger(
          null,
          loggerDetails,
          selectFeatureFlag(flags.LOGGER)(getState())
        );
        dispatch(publishPortalEventFailure(err));
        dispatch(
          updateNotification('Error adding zone to CMS event.', 'error', true)
        );
      });
  };
};

/**
 * Converts a BackOffice & Event Tool-only event to a CMS Event.
 *
 * @param data
 * @return {Function}
 */

export const createCMSEventFromBOEvent = (data) => {
  return (dispatch, getState) => {
    dispatch(createCMSEventBegin());
    const contextId = getState().app.contextId;
    const userName = getState().app.UserName;
    const loggerDetails = { contextId, payload: data, userName };
    const eventObj = Object.assign({}, data, {
      ContextId: contextId,
      UserName: userName,
    });
    createCMSEvent(eventObj)
      .then((response) => {
        const responseStatus = response.data.ResponseStatus;
        if (responseStatus.Message === 'Success' && !response.data.Message) {
          const eventId = response.data.EventId
            ? response.data.EventId
            : eventObj.EventId;
          dispatch(createCMSEventSuccess(eventId));
          dispatch(
            updateNotifications('Event Successfully Created In CMS.', 'success')
          );
          setTimeout(() => {
            dispatch({ type: 'HIDE_NOTIFICATION' });
          }, 8000);
        } else {
          Logger(
            response,
            loggerDetails,
            selectFeatureFlag(flags.LOGGER)(getState())
          );
          dispatch(createCMSEventFailure(responseStatus.Message));
          dispatch(
            updateNotification(
              'Error creating CMS event. The server returned : ' +
                responseStatus.Message,
              'error',
              true
            )
          );
        }
      })
      .catch((err) => {
        Logger(
          null,
          loggerDetails,
          selectFeatureFlag(flags.LOGGER)(getState())
        );
        dispatch(createCMSEventFailure(err));
        dispatch(
          updateNotification('Error creating CMS event.', 'error', true)
        );
      });
  };
};

/**
 * Saves zone setting using the Services API.
 *
 * @param data
 * @return {Function}
 */
export const saveZone = (data) => {
  return (dispatch, getState) => {
    dispatch(saveZoneBegin(data));
    const contextId = getState().app.contextId;
    const userName = getState().app.UserName;
    const loggerDetails = { contextId, payload: data, userName };
    saveZoneSettings(data)
      .then((response) => {
        const responseStatus = response.data.ResponseStatus;
        if (responseStatus.Message === 'Success') {
          dispatch(updateNotifications('Zone settings saved.', 'success'));
          setTimeout(() => {
            dispatch({ type: 'HIDE_NOTIFICATION' });
          }, 8000);
          redirectToPath(`/event/${data.EventId}/zones/${data.ZoneId}`);
          dispatch(saveZoneSuccess(data));
          dispatch(loadEventDetails(data.EventId));
        } else if (responseStatus.ErrorCode === '409') {
          dispatch(setDataModifiedWarning(true));
          dispatch(toggleIsLoading(false));
        } else {
          Logger(
            response,
            loggerDetails,
            selectFeatureFlag(flags.LOGGER)(getState())
          );
          dispatch(updateNotifications('Unable to save zone.', 'error', true));
        }
      })
      .catch((err) => {
        Logger(
          null,
          loggerDetails,
          selectFeatureFlag(flags.LOGGER)(getState())
        );
        dispatch(saveZoneFailure(err));
        dispatch(updateNotifications('Unable to save zone.', 'error', true));
      });
  };
};

/**
 * Update Flash Seat Settings using the Services API.
 *
 * @param data
 * @param eventId
 * @return {Function}
 */
export const saveFlashSeat = (data, eventId) => {
  return (dispatch, getState) => {
    const contextId = getState().app.contextId;
    const userName = getState().app.UserName;
    const loggerDetails = { contextId, payload: data, userName };
    dispatch(saveFlashSeatBegin());
    saveFlashSeatSettings(data)
      .then((response) => {
        const responseStatus = response.data.ResponseStatus;
        if (responseStatus.Message === 'Success') {
          dispatch(updateNotifications('Flash Seat Setting Saved.', 'success'));
          setTimeout(() => {
            dispatch({ type: 'HIDE_NOTIFICATION' });
          }, 8000);
          dispatch(saveFlashSeatSuccess(responseStatus.Message));
          dispatch(directToEventDetails(eventId));
        } else {
          Logger(
            response,
            loggerDetails,
            selectFeatureFlag(flags.LOGGER)(getState())
          );
          dispatch(
            updateNotifications(
              'Unable to save Flash seat settings.',
              'error',
              true
            )
          );
          dispatch(saveFlashSeatFailure(responseStatus.Message));
        }
      })
      .catch((err) => {
        Logger(
          null,
          loggerDetails,
          selectFeatureFlag(flags.LOGGER)(getState())
        );
        dispatch(
          updateNotifications(
            'Unable to save Flash seat settings. The server returned: ' + err,
            'error',
            true
          )
        );
        dispatch(saveFlashSeatFailure(err));
      });
  };
};

export const loadTemplateBase = (id) => {
  return (dispatch, getState) => {
    dispatch(loadTemplateBaseBegin());
    const contextId = getState().app.contextId;
    const userName = getState().app.UserName;
    const loggerDetails = { contextId, payload: {}, userName };
    getTemplate(contextId, id).then((response) => {
      const noError =
        response.data.hasOwnProperty('Templates') &&
        response.data.Templates.length > 0;
      if (noError) {
        const foundTemplate = cloneDeep(response.data.Templates[0]);
        const formatTemplate = camelcaseKeysDeep(foundTemplate);
        dispatch(loadTemplateBaseEventData(formatTemplate.eventId, contextId));
        dispatch(loadTemplateBaseSuccess(formatTemplate));
      } else {
        Logger(
          response,
          loggerDetails,
          selectFeatureFlag(flags.LOGGER)(getState())
        );
        dispatch(loadTemplateBaseFailure(response.data.ResponseStatus.Message));
        dispatch(
          updateNotifications(
            'Unable to load template base event.',
            'error',
            true
          )
        );
      }
    });
  };
};

/**
 * Load the user-selected template for the CMS (portal) event.
 *
 * @param {string} id
 * @return {Function}
 */
export const loadPortalTemplateBase = (id) => {
  return (dispatch, getState) => {
    dispatch(loadPortalTemplateBaseBegin());
    const contextId = getState().app.contextId;
    const userName = getState().app.UserName;
    const loggerDetails = { contextId, payload: {}, userName };
    getTemplate(contextId, id).then((response) => {
      const noError =
        response.data.hasOwnProperty('Templates') &&
        response.data.Templates.length > 0;
      if (noError) {
        const foundTemplate = cloneDeep(response.data.Templates[0]);
        const formatTemplate = camelcaseKeysDeep(foundTemplate);
        dispatch(
          loadPortalTemplateBaseEventData(formatTemplate.eventId, contextId)
        );
        dispatch(loadPortalTemplateBaseSuccess(formatTemplate));
      } else {
        Logger(
          response,
          loggerDetails,
          selectFeatureFlag(flags.LOGGER)(getState())
        );
        dispatch(
          loadPortalTemplateBaseFailure(response.data.ResponseStatus.Message)
        );
        dispatch(
          updateNotifications(
            'Unable to load the selected template.',
            'error',
            true
          )
        );
      }
    });
  };
};

/**
 * Load the Event used for a template using the Services API.
 *
 * @param prevEventId
 * @param contextId
 * @return {Function}
 */
export const loadTemplateBaseEventData = (prevEventId, contextId) => {
  return (dispatch, getState) => {
    const userName = getState().app.userName;
    const loggerDetails = { contextId, payload: {}, userName };
    const axsEvent = getState().event_details.event.aXSEvent;
    const rdatFlag = selectFeatureFlag(flags.RELATIVE_DATES_FE)(getState());
    getEvent(contextId, prevEventId).then((response) => {
      const noError = get(response, 'data.Event', '');
      if (noError) {
        const event = cloneDeep(response.data.Event);
        const formattedEvent = camelcaseKeysDeep(event);
        dispatch(
          loadTemplateBaseEventDataSuccess(formattedEvent, axsEvent, rdatFlag)
        );
      } else {
        Logger(
          response,
          loggerDetails,
          selectFeatureFlag(flags.LOGGER)(getState())
        );
        dispatch(
          updateNotifications(
            'Unable to load template base event.',
            'error',
            true
          )
        );
      }
    });
  };
};

/**
 * Load the base event to be used for the CMS (portal) event referenced from
 * the selected template.
 *
 * @param {string} prevEventId
 * @param {string} contextId
 * @return {Function}
 */
export const loadPortalTemplateBaseEventData = (prevEventId, contextId) => {
  return (dispatch, getState) => {
    // @todo: Update all AXSEvent objects to be `axsEvent` so we don't have to do this:
    const userName = getState().app.userName;
    const loggerDetails = { contextId, payload: {}, userName };
    const aXSEvent = getState().event_details.event.aXSEvent;
    const axsEvent = getState().event_details.event.axsEvent;
    const portalEvent = aXSEvent && !axsEvent ? aXSEvent : axsEvent;
    const rdatFlag = selectFeatureFlag(flags.RELATIVE_DATES_FE)(getState());
    getEvent(contextId, prevEventId).then((response) => {
      const noError = get(response, 'data.Event', '');
      if (noError) {
        const event = cloneDeep(response.data.Event);
        const formattedEvent = camelcaseKeysDeep(event);
        dispatch(
          loadPortalTemplateBaseEventDataSuccess(
            formattedEvent,
            portalEvent,
            rdatFlag
          )
        );
      } else {
        Logger(
          response,
          loggerDetails,
          selectFeatureFlag(flags.LOGGER)(getState())
        );
        dispatch(
          updateNotifications(
            'Unable to load template base event.',
            'error',
            true
          )
        );
      }
    });
  };
};

export const getCMSRevisionData = (eventId) => {
  return (dispatch) => {
    if (eventId) {
      dispatch(loadCMSRevisionsBegin());
      getEventRevisions(eventId)
        .then((response) => {
          const revisions = camelcaseKeysDeep(response.data);
          dispatch(loadCMSRevisionsSuccess(revisions));
        })
        .catch((err) => {
          dispatch(loadCMSRevisionsFailure(err));
        });
    }
  };
};

/**
 * Load the ticket text templates from the Services API.
 *
 * @return {Function}
 */
export const loadTicketTextTemplates = () => {
  return (dispatch, getState) => {
    dispatch(loadTicketTextTemplatesBegin());
    const contextId = getState().app.contextId;
    const userName = getState().app.UserName;
    const loggerDetails = { contextId, payload: {}, userName };
    getPrintTemplates(contextId, userName).then((response) => {
      const noError =
        response && response.data.hasOwnProperty('PrintTemplates');
      if (noError) {
        const templates = cloneDeep(response.data.PrintTemplates);
        dispatch(loadTicketTextTemplatesSuccess(camelcaseKeysDeep(templates)));
      } else {
        Logger(
          response,
          loggerDetails,
          selectFeatureFlag(flags.LOGGER)(getState())
        );
        dispatch(
          updateNotifications(
            'An error has occurred loading the Ticketing Text Templates.',
            'error',
            true
          )
        );
        dispatch(
          loadTicketTextTemplatesFailure(
            'An error has occurred loading the Ticketing Text Templates.'
          )
        );
      }
    });
  };
};

/**
 * Load the email templates from the Services API.
 *
 * @return {Function}
 */
export const fetchEmailTemplates = () => {
  return (dispatch, getState) => {
    const contextId = getState().app.contextId;
    const userName = getState().app.UserName;
    const loggerDetails = { contextId, payload: {}, userName };

    dispatch(fetchEmailTemplatesBegin());
    return getEmailTemplates(contextId)
      .then((response) => {
        if (response.status === 200) {
          const formattedData = camelcaseKeysDeep(response.data);
          dispatch(fetchEmailTemplatesSuccess(formattedData));
        } else {
          Logger(
            response,
            loggerDetails,
            selectFeatureFlag(flags.LOGGER)(getState())
          );
          dispatch(
            updateNotifications(
              'Failed to fetch email templates.',
              'error',
              true
            )
          );
          fetchEmailTemplatesFailure('Failed to fetch email templates.');
        }
      })
      .catch((err) => {
        dispatch(fetchEmailTemplatesFailure(err));
      });
  };
};

/**
 * Load the tax profiles from the Services API.
 *
 * @return {Function}
 */
export const fetchTaxProfiles = () => {
  return (dispatch, getState) => {
    const contextId = getState().app.contextId;
    const userName = getState().app.UserName;
    const loggerDetails = { contextId, payload: {}, userName };

    dispatch(fetchTaxProfileBegin());
    return getTaxProfiles(contextId)
      .then((response) => {
        if (response.status === 200) {
          const formattedData = camelcaseKeysDeep(response.data);
          dispatch(fetchTaxPofileSuccess(formattedData));
        } else {
          Logger(
            response,
            loggerDetails,
            selectFeatureFlag(flags.LOGGER)(getState())
          );
          dispatch(
            updateNotifications('Failed to fetch Tax Profiles.', 'error', true)
          );
          fetchTaxProfileFailure('Failed to fetch Tax Profiles.');
        }
      })
      .catch((err) => {
        dispatch(fetchTaxProfileFailure(err));
      });
  };
};

/**
 * Load the Sites from the AXS Event API.
 *
 * @param venueId
 * @return {Function}
 */
export const loadSites = (venueId) => {
  return (dispatch, getState) => {
    const contextId = getState().app.ContextId;
    const userName = getState().app.userName;
    const loggerDetails = { contextId, payload: {}, userName };
    dispatch(getSitesBegin());
    searchSites(venueId)
      .then((response) => {
        const noError = response.data.hasOwnProperty('display');
        if (noError) {
          const sites = cloneDeep(response.data.display);
          dispatch(
            getSitesSuccess(
              sites,
              getState().event_details.eventCreation.eventLookupId === ''
            )
          );
        } else {
          Logger(
            response,
            loggerDetails,
            selectFeatureFlag(flags.LOGGER)(getState())
          );
          dispatch(
            updateNotifications(
              'An error has occurred loading the CMS Sites.',
              'error',
              true
            )
          );
          dispatch(getSitesFailure());
        }
      })
      .catch((err) => {
        dispatch(getSitesFailure(err));
        dispatch(
          updateNotifications('Unable to load the CMS Sites.', 'error', true)
        );
      });
  };
};

const ACTION_HANDLERS = {
  [actions.LOAD_TEMPLATE_BEGIN]: (state) => {
    const newState = {};
    Object.assign(newState, state, { isLoadingTemplate: true });
    return newState;
  },
  [actions.LOAD_TEMPLATE_SUCCESS]: (state, action) => {
    const newState = {};
    const updatedEventCreation = {};
    const evtCategory = Object.values(action.template.categories);
    let dates;

    if (action.isNewEvent) {
      dates = receiveAndFormatTemplateDates(
        state.eventCreation.dates,
        action.template.relativeDates,
        action.rdatFlag
      ).dates;

      // If isNewEvent get category data from tempalte
      updatedEventCreation.selectedEventCategory = formatEventsCategory(
        action.template.categories
      );
      updatedEventCreation.selectedSeasonCategory = formatSeasonsCategory(
        action.template.categories
      );
    } else {
      dates = { ...state.eventCreation.dates };
    }

    const eventCreation = Object.assign(
      updatedEventCreation,
      state.eventCreation,
      { axsVenueId: action.template.aXSVenueId },
      { dates },
      { axsVenueId: action.template.axsVenueId },
      { templateName: action.template.name },
      { templateId: action.template.id },
      { eventId: action.template.eventId },
      { venueId: action.template.venueId },
      { eventCategory: evtCategory },
      { venueCode: action.template.venueCode },
      { timeZone: action.template.timeZone },
      { venue: action.template.venueName },
      { 
        venueManagerId: action.isNewEvent ? action.template.venueManagerId || '' : state.eventCreation.venueManagerId,
        axsManagerId: action.isNewEvent ? action.template.axsManagerId || '' : state.eventCreation.axsManagerId,
      },
    );

    Object.assign(
      newState,
      state,
      { isLoadingTemplate: false },
      { isFetchingTemplate: false },
      { importedTemplateSuccessStep1: true },
      { eventCreation }
    );

    return newState;
  },
  [actions.LOAD_TEMPLATE_FAILURE]: (state) => {
    const newState = {};
    Object.assign(newState, state, { isLoadingTemplate: false });
    return newState;
  },
  [LOAD_TEMPLATES_SUCCESS]: (state) => {
    const newState = {};
    const updatedTemplates = {};
    Object.assign(
      updatedTemplates,
      { fetchTemplatesSuccess: true },
      { isFetchingTemplates: false }
    );
    Object.assign(newState, state, updatedTemplates);
    return newState;
  },
  [actions.FETCH_TEMPLATES_BEGIN]: (state) => {
    const newState = {};
    Object.assign(newState, state, { isFetchingTemplates: true });
    return newState;
  },
  [actions.FETCH_TEMPLATES_SUCCESS]: (state) => {
    const newState = {};
    Object.assign(newState, state, { isFetchingTemplates: false });
    return newState;
  },
  [REMOVE_RELATIVE_DATE]: (state, action) => {
    const newState = {};
    const newEventCreation = {};
    const updatedDates = {};
    for (const item in state.eventCreation.dates) {
      const curr = state.eventCreation.dates[item];
      if (curr.fieldId === action.fieldId) {
        const dateTimeField = removeRelativeDateValues(curr);
        Object.assign(updatedDates, { [item]: dateTimeField });
      } else {
        Object.assign(updatedDates, { [item]: curr });
      }
    }
    Object.assign(newEventCreation, state.eventCreation, {
      dates: updatedDates,
    });
    Object.assign(newState, state, { eventCreation: newEventCreation });
    return newState;
  },
  [CALCULATE_RELATIVE_DATES]: (state, action) => {
    const { dateObject, fieldId } = action;
    const anchorDate = dateObject;
    const newState = {};
    const newEventCreation = {};
    const updatedDates = {};
    for (const item in state.eventCreation.dates) {
      const curr = state.eventCreation.dates[item];
      if (curr.anchor === fieldId && curr.isRelative) {
        const {
          operator,
          specificTime,
          months,
          weeks,
          days,
          hours,
          minutes,
        } = curr;
        const calculatedDate = calculateRelativeDate(
          anchorDate,
          operator,
          months,
          weeks,
          days,
          hours,
          minutes,
          specificTime
        ).format(dateFormats.API_DATE_TIME_FORMAT);
        const dateTime = Object.assign({}, curr, { date: calculatedDate });
        Object.assign(updatedDates, { [item]: dateTime });
      } else {
        Object.assign(updatedDates, { [item]: curr });
      }
    }
    Object.assign(newEventCreation, state.eventCreation, {
      dates: updatedDates,
    });
    Object.assign(newState, state, { eventCreation: newEventCreation });
    return newState;
  },
  [actions.HANDLE_EVENT_TEMPLATE_CHANGE]: (state, { templateId }) => {
    const newState = {};
    const newEventCreation = {};
    Object.assign(newEventCreation, state.eventCreation, {
      templateId,
    });
    Object.assign(newState, state, { eventCreation: newEventCreation });
    return newState;
  },
  [actions.HANDLE_ON_SALE_DATE_SAVE]: (state, { data }) => {
    const { date } = data;
    const newState = {};
    const newEventCreation = {};
    const generalOnsaleDate = Object.assign(
      {},
      state.eventCreation.dates.generalOnsaleDate,
      { date }
    );
    const dates = Object.assign({}, state.eventCreation.dates, {
      generalOnsaleDate,
    });
    Object.assign(newEventCreation, state.eventCreation, { dates });
    Object.assign(newState, state, { eventCreation: newEventCreation });
    return newState;
  },
  [actions.HANDLE_EVENT_START_DATE_SAVE]: (state, action) => {
    const { date } = action;
    const newState = {};
    const newEventCreation = {};
    const eventStartDate = Object.assign(
      {},
      state.eventCreation.dates.eventStartDate,
      { date }
    );
    const dates = Object.assign({}, state.eventCreation.dates, {
      eventStartDate,
    });
    Object.assign(newEventCreation, state.eventCreation, { dates });
    Object.assign(newState, state, { eventCreation: newEventCreation });
    return newState;
  },
  [actions.HANDLE_EVENT_END_DATE_SAVE]: (state, { data }) => {
    const newState = {};
    const newEventCreation = {};
    const eventEndDate = Object.assign(
      {},
      state.eventCreation.dates.eventEndDate,
      data
    );
    const dates = Object.assign({}, state.eventCreation.dates, {
      eventEndDate,
    });
    Object.assign(newEventCreation, state.eventCreation, { dates });
    Object.assign(newState, state, { eventCreation: newEventCreation });
    return newState;
  },
  [actions.HANDLE_EVENT_NAME_INPUT]: (state, action) => {
    const newState = {};
    const newEventCreation = {};
    Object.assign(newEventCreation, state.eventCreation, {
      eventName: action.text,
    });
    Object.assign(newState, state, { eventCreation: newEventCreation });
    return newState;
  },
  [actions.HANDLE_ORIGINAL_TEMPLATE_ID]: (state, action) => {
    const newState = {};
    const newEventCreation = {};
    Object.assign(newEventCreation, state.eventCreation, {
      newOriginalTemplateId: action.templateId,
      templateName: action.templateName,
    });
    Object.assign(
      newState,
      state,
      { importedTemplateSuccessStep1: true },
      { eventCreation: newEventCreation }
    );
    return newState;
  },
  [actions.FETCH_VENUE_MAPS_BEGIN]: (state) => {
    const newState = {};
    Object.assign(newState, state);
    return newState;
  },
  [actions.FETCH_VENUE_MAPS_SUCCESS]: (state, action) => {
    const newState = {};
    Object.assign(newState, state, { venueMaps: action.venueMaps.VenueMaps });
    return newState;
  },
  [actions.HANDLE_SELECT_VENUE_MAP_FROM_DROPDOWN]: (state, action) => {
    const newState = {};
    const newEventCreation = {};
    Object.assign(newEventCreation, state.eventCreation, {
      mapLayout: action.venue,
    }),
      Object.assign(newState, state, { eventCreation: newEventCreation });
    return newState;
  },
  [actions.GET_AXS_MANAGER_OPTIONS_BEGIN]: (state) => {
    return { ...state };
  },
  [actions.GET_AXS_MANAGER_OPTIONS_FAILURE]: (state, action) => {
    return { ...state, errorMessage: action.error };
  },
  [actions.GET_AXS_MANAGER_OPTIONS_SUCCESS]: (state, action) => {
    const newState = {};
    const newEventCreation = {};
    const data = [
      { id: null, name: null },
      ...action.axsManagerOptions.map((n) => ({
        id: n.id,
        name: n.name.substring(0, 23),
      })),
    ];
    Object.assign(newEventCreation, state.eventCreation, {
      axsManagerOptions: data,
    });
    Object.assign(newState, state, { eventCreation: newEventCreation });
    return newState;
  },
  [actions.HANDLE_AXS_MANAGER_CHANGE]: (state, action) => {
    const newState = {};
    const newEventCreation = {};
    Object.assign(newEventCreation, state.eventCreation, {
      axsManagerId: action.id,
    });
    Object.assign(newState, state, { eventCreation: newEventCreation });
    return newState;
  },
  [actions.GET_VENUE_MANAGER_OPTIONS_BEGIN]: (state) => {
    return { ...state };
  },
  [actions.GET_VENUE_MANAGER_OPTIONS_FAILURE]: (state, action) => {
    return { ...state, errorMessage: action.error };
  },
  [actions.GET_VENUE_MANAGER_OPTIONS_SUCCESS]: (state, action) => {
    const newState = {};
    const newEventCreation = {};
    const data = [
      { id: null, name: null },
      ...action.venueManagerOptions.map((n) => ({
        id: n.id,
        name: n.name.substring(0, 23),
      })),
    ];
    Object.assign(newEventCreation, state.eventCreation, {
      venueManagerOptions: data,
    });
    Object.assign(newState, state, { eventCreation: newEventCreation });
    return newState;
  },
  [actions.HANDLE_VENUE_MANAGER_CHANGE]: (state, action) => {
    const newState = {};
    const newEventCreation = {};
    Object.assign(newEventCreation, state.eventCreation, {
      venueManagerId: action.id,
    });
    Object.assign(newState, state, { eventCreation: newEventCreation });
    return newState;
  },
  [actions.HANDLE_CMS_AGE_CHANGE]: (state, action) => {
    const newState = {};
    const newEventCreation = {};
    const newAxsEvent = {};
    Object.assign(newAxsEvent, state.eventCreation.axsEvent, {
      age: action.newAge,
    });
    Object.assign(newEventCreation, state.eventCreation, {
      axsEvent: newAxsEvent,
    });
    Object.assign(newState, state, { eventCreation: newEventCreation });
    return newState;
  },
  [actions.HANDLE_CMS_PUBLISH_STATUS_CHANGE]: (state, action) => {
    const newState = {};
    const newEventCreation = {};
    const newAxsEvent = {};
    Object.assign(newAxsEvent, state.eventCreation.axsEvent, {
      publishStatus: action.newPublishStatus,
    });
    Object.assign(newEventCreation, state.eventCreation, {
      axsEvent: newAxsEvent,
    });
    Object.assign(newState, state, { eventCreation: newEventCreation });
    return newState;
  },
  [actions.HANDLE_CMS_EDP_STATUS_CHANGE]: (state, action) => {
    const newState = {};
    const newEventCreation = {};
    Object.assign(newEventCreation, state.eventCreation, {
      isPublicEDP: action.status ? true : false,
    });
    Object.assign(newState, state, { eventCreation: newEventCreation });
    return newState;
  },
  [actions.HANDLE_CMS_STATUS_CHANGE]: (state, action) => {
    const newState = {};
    const newEventCreation = {};
    const newAxsEvent = {};
    const newTicketing = {};
    const ticketing = state.eventCreation.axsEvent
      ? state.eventCreation.axsEvent.ticketing
      : {};

    Object.assign(newTicketing, ticketing, {
      statusId: action.newStatus,
    });
    Object.assign(newAxsEvent, state.eventCreation.axsEvent, {
      ticketing: newTicketing,
    });
    Object.assign(newEventCreation, state.eventCreation, {
      axsEvent: newAxsEvent,
    });
    Object.assign(newState, state, { eventCreation: newEventCreation });
    return newState;
  },
  [actions.HANDLE_CMS_BIO_CHANGE]: (state, action) => {
    const newState = {};
    const newEventCreation = {};
    const newAxsEvent = {};
    Object.assign(newAxsEvent, state.eventCreation.axsEvent, {
      bio: action.bioText,
    });
    Object.assign(newEventCreation, state.eventCreation, {
      axsEvent: newAxsEvent,
    });
    Object.assign(newState, state, { eventCreation: newEventCreation });
    return newState;
  },
  [actions.AUTO_PUBLISH_OFFERS_BEGIN]: (state) => {
    const newState = {};
    Object.assign(newState, state, { isLoading: true });
    return newState;
  },
  [actions.AUTO_PUBLISH_OFFERS_FAILURE]: (state) => {
    const newState = {};
    Object.assign(newState, state, { isLoading: false });
    return newState;
  },
  [actions.AUTO_PUBLISH_OFFERS_SUCCESS]: (state) => {
    const newState = {};
    Object.assign(newState, state, { isLoading: false });
    return newState;
  },
  [actions.HANDLE_CMS_DESCRIPTION_CHANGE]: (state, action) => {
    const newState = {};
    const newEventCreation = {};
    const newAxsEvent = {};
    Object.assign(newAxsEvent, state.eventCreation.axsEvent, {
      description: action.description,
    });
    Object.assign(newEventCreation, state.eventCreation, {
      axsEvent: newAxsEvent,
    });
    Object.assign(newState, state, { eventCreation: newEventCreation });
    return newState;
  },
  [actions.HANDLE_CMS_MAJOR_CATEGORY_CHANGE]: (state, action) => {
    const newState = {};
    const newEventCreation = {};
    let newAxsEvent = { ...state.eventCreation.axsEvent };
    const newMajorCategoryId = action.newMajorCategoryId;
    let level = action.level;
    //If level = null we add to the next available slot
    if (level === null) {
      if (!state.eventCreation.axsEvent.majorCategoryId2) level = 2;
      else if (!state.eventCreation.axsEvent.majorCategoryId3) level = 3;
    }

    let defaultMinorCategoryId;
    //When Major Category Changes, we need to default to a Minor Category
    if (newMajorCategoryId === 1) defaultMinorCategoryId = DefaultGenre1;
    else if (action.newMajorCategoryId === 2)
      defaultMinorCategoryId = DefaultGenre2;
    else if (action.newMajorCategoryId === 3)
      defaultMinorCategoryId = DefaultGenre3;
    else {
      //If newMajorCategoryId = null, we want to remove that genre
      newAxsEvent = cloneDeep(state.eventCreation.axsEvent);
      if (level === 2) {
        delete newAxsEvent.majorCategoryId2;
        delete newAxsEvent.minorCategoryId2;
        delete newAxsEvent.majorCategoryId2Label;
        delete newAxsEvent.minorCategoryId2Label;
      } else if (level === 3) {
        delete newAxsEvent.majorCategoryId3;
        delete newAxsEvent.minorCategoryId3;
        delete newAxsEvent.majorCategoryId3Label;
        delete newAxsEvent.minorCategoryId3Label;
      }
    }
    if (newMajorCategoryId !== null) {
      if (level === 1) {
        Object.assign(newAxsEvent, state.eventCreation.axsEvent, {
          majorCategoryId1: newMajorCategoryId,
          minorCategoryId1: defaultMinorCategoryId,
        });
      } else if (level === 2) {
        Object.assign(newAxsEvent, state.eventCreation.axsEvent, {
          majorCategoryId2: newMajorCategoryId,
          minorCategoryId2: defaultMinorCategoryId,
        });
      } else if (level === 3) {
        Object.assign(newAxsEvent, state.eventCreation.axsEvent, {
          majorCategoryId3: newMajorCategoryId,
          minorCategoryId3: defaultMinorCategoryId,
        });
      }
    }
    Object.assign(newEventCreation, state.eventCreation, {
      axsEvent: newAxsEvent,
    });
    Object.assign(newState, state, { eventCreation: newEventCreation });
    return newState;
  },
  [actions.HANDLE_CMS_MINOR_CATEGORY_CHANGE]: (state, action) => {
    const newState = {};
    const newEventCreation = {};
    const newAxsEvent = {};
    const level = action.level;
    if (level === 1) {
      Object.assign(newAxsEvent, state.eventCreation.axsEvent, {
        minorCategoryId1: action.newMinorCategoryId,
      });
    } else if (level === 2) {
      Object.assign(newAxsEvent, state.eventCreation.axsEvent, {
        minorCategoryId2: action.newMinorCategoryId,
      });
    } else if (level === 3) {
      Object.assign(newAxsEvent, state.eventCreation.axsEvent, {
        minorCategoryId3: action.newMinorCategoryId,
      });
    }
    Object.assign(newEventCreation, state.eventCreation, {
      axsEvent: newAxsEvent,
    });
    Object.assign(newState, state, { eventCreation: newEventCreation });
    return newState;
  },
  [actions.FETCH_VENUE_MAPS_FAILURE]: (state, action) => {
    const newState = {};
    Object.assign(newState, state, { errorMessage: action.failureMessage });
    return newState;
  },
  [actions.LOAD_CREATE_EVENT_DETAILS_BEGIN]: (state) => {
    return Object.assign({}, state, { isLoading: true });
  },
  [actions.LOAD_CREATE_EVENT_DETAILS_SUCCESS]: (state, action) => {
    const event = receiveAndFormatEvent(action.event, action.flag);
    if (event.hasOwnProperty('aXSEvent')) {
      event.axsEvent = event.aXSEvent;
      // sync property spelling on event offer and template offer
      delete event.aXSEvent;
    }
    const newState = {};
    const newEventCreation = {};
    let axsEvent = null;
    let doorPrice = '';
    if (event.axsEvent && event.axsEvent.doorPrice) {
      doorPrice =
        event.axsEvent.doorPrice && event.axsEvent.doorPrice.includes('-')
          ? event.axsEvent.doorPrice
          : `0-${event.axsEvent.doorPrice}`;
    }
    if (event.axsEvent && action.flag) {
      // cms event probably needs own date formatter func like ct event dates
      const doorDate =
        event.axsEvent.doorDate &&
        event.axsEvent.doorDate.dateTime &&
        event.axsEvent.doorDate.dateTime !== '0001-01-01T00:00:00.0000000' &&
        event.axsEvent.eventDateTime !== 'TBD'
          ? {
              fieldId: event.axsEvent.doorDate.fieldId,
              date: event.axsEvent.doorDate.dateTime,
            }
          : null;
      axsEvent = Object.assign({}, action.event.aXSEvent, {
        doorDate,
        doorPrice,
      });
    } else if (action.event.aXSEvent && !action.flag) {
      const doorDate = {
        fieldId: DOOR_DATE_FIELD_ID,
        date: action.event.aXSEvent.doorDateTime,
      };
      axsEvent = Object.assign({}, action.event.aXSEvent, {
        doorDate,
        doorPrice,
      });
    }
    const isNewEvent = Number(action.event.id) === 0;
    const siteData = action.event.aXSEvent && action.event.aXSEvent.siteData;
    Object.assign(newEventCreation, state.eventCreation, event, {
      templateName: '',
      templateId: '',
      venue: action.event.venue,
      venueId: action.event.venueId,
      axsVenueId: action.event.aXSVenueId,
      axsEvent,
      eventId: action.event.id,
      eventName: action.event.eventName,
      mapLayout: '',
      promoterId: event.promoterId || 0,
      media: action.event.aXSEvent && action.event.aXSEvent.media,
      notes: action.event.notes,
      id: action.event.description,
      eventLookupId: action.event.lookupId,
      originalTemplateId: action.event.originalTemplateId
        ? action.event.originalTemplateId
        : '',
      timeZone: action.event.timeZone,
      isLoading: false,
      selectedEventCategory: formatEventsCategory(action.event.categories),
      selectedSeasonCategory: formatSeasonsCategory(action.event.categories),
      isPublicEDP: getIsPublicEDP(isNewEvent, siteData),
    });
    Object.assign(
      newState,
      state,
      { isLoading: false },
      { eventCreation: newEventCreation }
    );
    return newState;
  },
  [actions.LOAD_CREATE_EVENT_DETAILS_FAILURE]: (state) => {
    const newState = {};
    Object.assign(newState, state, { isLoading: false });
    return newState;
  },
  [actions.HANDLE_EVENT_LOOKUP_ID_INPUT]: (state, action) => {
    const newState = {};
    const newEventCreation = {};
    Object.assign(newEventCreation, state.eventCreation, {
      eventLookupId: action.text,
    });
    Object.assign(newState, state, { eventCreation: newEventCreation });
    return newState;
  },
  [actions.HANDLE_PRICE_LEVEL_OVERRIDE_IN_MANIFEST]: (state, action) => {
    const newState = {};
    const newEventCreation = {};
    Object.assign(newEventCreation, state.eventCreation, {
      priceLevelOverrideInManifest: action.value,
    });
    Object.assign(newState, state, { eventCreation: newEventCreation });
    return newState;
  },
  [actions.STORE_EVENT_LOOKUP_ID]: (state, action) => {
    const newState = {};
    const newEventCreation = {};
    Object.assign(newEventCreation, state.eventCreation, {
      eventLookupId: action.eventLookupId,
    });
    Object.assign(newState, state, { eventCreation: newEventCreation });
    return newState;
  },
  [actions.EVENT_LOOKUPID_CHECK_BEGIN]: (state) => {
    const newState = {};
    Object.assign(newState, state);
    return newState;
  },
  [actions.EVENT_LOOKUPID_CHECK_FAILURE]: (state, action) => {
    const newState = {};
    Object.assign(
      newState,
      state,
      { isUniqueEventLookupId: false },
      { errorMessage: action.failureMessage }
    );
    return newState;
  },
  [actions.EVENT_LOOKUPID_CHECK_SUCCESS]: (state) => {
    const newState = {};
    Object.assign(newState, state, { isUniqueEventLookupId: true });
    return newState;
  },
  [actions.CREATE_INITIAL_TIME_VALUES]: (state, action) => {
    const newState = {};
    const newEventCreation = {};
    Object.assign(
      newEventCreation,
      state.eventCreation,
      { startDate: action.startDate },
      { endDate: action.endDate },
      { flashDeliveryStartDate: action.startDate },
      { standardDeliveryDate: action.startDate },
      { eTicketStartDate: action.startDate }
    );
    Object.assign(newState, state, { eventCreation: newEventCreation });
    return newState;
  },
  [actions.HANDLE_FLASH_DATE_SAVE]: (state, { data }) => {
    const newState = {};
    const newEventCreation = {};
    const flashDeliveryStartDate = Object.assign(
      {},
      state.eventCreation.dates.flashDeliveryStartDate,
      data
    );
    const dates = Object.assign({}, state.eventCreation.dates, {
      flashDeliveryStartDate,
    });
    Object.assign(newEventCreation, state.eventCreation, { dates });
    Object.assign(newState, state, { eventCreation: newEventCreation });
    return newState;
  },
  [actions.HANDLE_STANDARD_DELIVERY_DATE_SAVE]: (state, { data }) => {
    const newState = {};
    const newEventCreation = {};
    const standardDeliveryDate = Object.assign(
      {},
      state.eventCreation.dates.standardDeliveryDate,
      data
    );
    const dates = Object.assign({}, state.eventCreation.dates, {
      standardDeliveryDate,
    });
    Object.assign(newEventCreation, state.eventCreation, { dates });
    Object.assign(newState, state, { eventCreation: newEventCreation });
    return newState;
  },
  [actions.HANDLE_ANNOUNCEMENT_DATE_SAVE]: (state, { data }) => {
    const newState = {};
    const newEventCreation = {};
    const announcementDate = Object.assign(
      {},
      state.eventCreation.dates.announcementDate,
      data
    );
    const dates = Object.assign({}, state.eventCreation.dates, {
      announcementDate,
    });
    Object.assign(newEventCreation, state.eventCreation, { dates });
    Object.assign(newState, state, { eventCreation: newEventCreation });
    return newState;
  },
  [actions.HANDLE_EXPIRATION_DATE_SAVE]: (state, { data }) => {
    const newState = {};
    const newEventCreation = {};
    const expirationDate = Object.assign(
      {},
      state.eventCreation.dates.expirationDate,
      data
    );
    const dates = Object.assign({}, state.eventCreation.dates, {
      expirationDate,
    });
    Object.assign(newEventCreation, state.eventCreation, { dates });
    Object.assign(newState, state, { eventCreation: newEventCreation });
    return newState;
  },
  [actions.HANDLE_EXPIRATION_DATE_RESET]: (state) => {
    const newState = {};
    const newEventCreation = {};
    const expirationDate = Object.assign(
      {},
      state.eventCreation.dates.expirationDate,
      {
        date: '',
      }
    );
    const dates = Object.assign({}, state.eventCreation.dates, {
      expirationDate,
    });
    Object.assign(newEventCreation, state.eventCreation, { dates });
    Object.assign(newState, state, { eventCreation: newEventCreation });
    return newState;
  },
  [actions.HANDLE_DOORS_DATE_SAVE]: (state, { date }) => {
    const newState = {
      ...state,
      eventCreation: {
        ...state.eventCreation,
        axsEvent: {
          ...state.eventCreation.axsEvent,
          doorDate: {
            ...state.eventCreation.axsEvent.doorDate,
            date: date,
          },
        },
      },
    };
    return newState;
  },
  [actions.HANDLE_SITE_VISIBILITY]: (state, { label }) => {
    const newState = {};
    const newEventCreation = {};

    const selectedSites = Object.assign([], state.eventCreation.visibleOnSites);
    const index = findIndex(selectedSites, { name: label });
    const selection = selectedSites[Number(index)];
    selectedSites[Number(index)] = {
      id: selection.id,
      name: selection.name,
      default: selection.default === 'selected' ? 'unselected' : 'selected',
    };

    Object.assign(newEventCreation, state.eventCreation, {
      visibleOnSites: selectedSites,
    });
    Object.assign(newState, state, { eventCreation: newEventCreation });
    return newState;
  },
  [actions.HANDLE_PRESENTED_BY]: (state, { data }) => {
    const axsEventTitle = state.eventCreation.axsEvent
      ? state.eventCreation.axsEvent.title
      : {};
    return {
      ...state,
      eventCreation: {
        ...state.eventCreation,
        axsEvent: {
          ...state.eventCreation.axsEvent,
          title: {
            ...axsEventTitle,
            presentedByText: data,
          },
        },
      },
    };
  },
  [HANDLE_PROMOTER_CHANGE]: (state, action) => {
    const newState = {};
    const newEventCreation = {};
    Object.assign(newEventCreation, state.eventCreation, {
      promoterId: action.id,
    });
    Object.assign(newState, state, { eventCreation: newEventCreation });
    return newState;
  },
  [actions.FETCH_SHORT_CODES_BEGIN]: (state) => {
    return { ...state };
  },
  [actions.FETCH_SHORT_CODES_FAILURE]: (state, action) => {
    return { ...state, errorMessage: action.error };
  },
  [actions.FETCH_SHORT_CODES_SUCCESS]: (state, action) => {
    const formattedShortCodes = Object.keys(action.shortCodes).map((code) => {
      return {
        id: code,
        value: action.shortCodes[code],
      };
    });
    return { ...state, shortCodeOptions: formattedShortCodes };
  },
  [actions.HANDLE_SHORT_CODES_CHANGE]: (state, action) => {
    return {
      ...state,
      eventCreation: {
        ...state.eventCreation,
        axsEvent: {
          ...state.eventCreation.axsEvent,
          shortCodeId: action.id,
        },
      },
    };
  },
  [actions.HANDLE_TOUR]: (state, { data }) => {
    const axsEventTitle = state.eventCreation.axsEvent
      ? state.eventCreation.axsEvent.title
      : {};
    return {
      ...state,
      eventCreation: {
        ...state.eventCreation,
        axsEvent: {
          ...state.eventCreation.axsEvent,
          title: {
            ...axsEventTitle,
            tour: data,
          },
        },
      },
    };
  },
  [actions.HANDLE_DOOR_PRICE]: (state, { data }) => {
    return {
      ...state,
      eventCreation: {
        ...state.eventCreation,
        axsEvent: {
          ...state.eventCreation.axsEvent,
          doorPrice: {
            low: data.split('-')[0],
            high: data.split('-')[1],
          },
        },
      },
    };
  },
  [actions.HANDLE_TICKET_PRICE]: (state, { data }) => {
    return {
      ...state,
      eventCreation: {
        ...state.eventCreation,
        axsEvent: {
          ...state.eventCreation.axsEvent,
          ticketPrice: data,
        },
      },
    };
  },
  [actions.HANDLE_ETICKET_DATE_SAVE]: (state, { data }) => {
    const newState = {};
    const newEventCreation = {};
    const eTicketStartDate = Object.assign(
      {},
      state.eventCreation.dates.eTicketStartDate,
      data
    );
    const dates = Object.assign({}, state.eventCreation.dates, {
      eTicketStartDate,
    });
    Object.assign(newEventCreation, state.eventCreation, { dates });
    Object.assign(newState, state, { eventCreation: newEventCreation });
    return newState;
  },
  [actions.SET_GENERAL_ONSALE_DATE]: (state, { data }) => {
    const newState = {};
    const newEventCreation = {};
    const generalOnsaleDate = Object.assign(
      {},
      state.eventCreation.dates.generalOnsaleDate,
      data
    );
    const dates = Object.assign({}, state.eventCreation.dates, {
      generalOnsaleDate,
    });
    Object.assign(newEventCreation, state.eventCreation, { dates });
    Object.assign(newState, state, { eventCreation: newEventCreation });
    return newState;
  },
  [actions.DIRECT_TO_EVENT_DETAILS]: () => {
    const newState = {};
    Object.assign(newState, initialState, { isLoading: true });
    return newState;
  },
  [actions.DIRECT_TO_CREATE_EDIT_EVENT]: () => {
    const newState = {};
    Object.assign(newState, initialState, { isLoading: true });
    return newState;
  },
  [actions.UPDATE_EVENT_BEGIN]: (state) => {
    const newState = {};
    Object.assign(newState, state, { isSaving: true });
    return newState;
  },
  [actions.UPDATE_EVENT_SUCCESS]: (state) => {
    const newState = {};
    Object.assign(newState, state, { isSaving: false });
    return newState;
  },
  [actions.UPDATE_EVENT_FAILURE]: (state) => {
    const newState = {};
    Object.assign(newState, state, { isSaving: false, isLoading: false });
    return newState;
  },
  [actions.RESET_EVENT]: () => {
    const eventCreation = Object.assign(
      {},
      JSON.parse(eventCreationInitialSerialized)
    );
    const newState = Object.assign({}, initialState, { eventCreation });
    return newState;
  },
  [actions.PUBLISH_EVENT_BEGIN]: (state) => {
    const newState = {};
    Object.assign(newState, state, { isSaving: true });
    return newState;
  },
  [actions.PUBLISH_EVENT_SUCCESS]: (state) => {
    const newState = {};
    Object.assign(newState, state, { isSaving: false });
    return newState;
  },
  [actions.PUBLISH_EVENT_FAILURE]: (state, action) => {
    const newState = {};
    Object.assign(newState, state, {
      isSaving: false,
      isLoading: false,
      errorMessage: action.failureMessage,
    });
    return newState;
  },
  [actions.PUBLISH_PORTAL_EVENT_BEGIN]: (state) => {
    const newState = {};
    Object.assign(newState, state, { isSavingPortalEvent: true });
    return newState;
  },
  [actions.PUBLISH_PORTAL_EVENT_SUCCESS]: (state) => {
    const newState = {};
    Object.assign(newState, state, { isSavingPortalEvent: false });
    return newState;
  },
  [actions.PUBLISH_PORTAL_EVENT_FAILURE]: (state, action) => {
    const newState = {};
    Object.assign(newState, state, {
      isSavingPortalEvent: false,
      isLoading: false,
      errorMessage: action.failureMessage,
    });
    return newState;
  },
  [actions.SAVE_ORIGINAL_TEMPLATE_ID_BEGIN]: (state) => {
    const newState = {};
    Object.assign(newState, state);
    return newState;
  },
  [actions.SAVE_ORIGINAL_TEMPLATE_ID_SUCCESS]: (state) => {
    const newState = {};
    Object.assign(newState, state);
    return newState;
  },
  [actions.SAVE_ORIGINAL_TEMPLATE_ID_FAILURE]: (state, action) => {
    const newState = {};
    Object.assign(newState, state, {
      isSaving: false,
      errorMessage: action.err,
    });
    return newState;
  },
  [actions.CREATE_CMS_EVENT_BEGIN]: (state) => {
    const newState = {};
    Object.assign(
      newState,
      state,
      { isSavingCMSEvent: true },
      { isLoading: true }
    );
    return newState;
  },
  [actions.CREATE_CMS_EVENT_SUCCESS]: (state) => {
    const newState = {};
    Object.assign(
      newState,
      state,
      { isSavingCMSEvent: false },
      { isLoading: false }
    );
    return newState;
  },
  [actions.CREATE_CMS_EVENT_FAILURE]: (state, action) => {
    const newState = {};
    Object.assign(newState, state, {
      isSavingCMSEvent: false,
      isLoading: false,
      errorMessage: action.failureMessage,
    });
    return newState;
  },
  [actions.CHECK_FOR_EVENT_OVERLAP_BEGIN]: (state) => {
    const newState = {};
    Object.assign(newState, state);
    return newState;
  },
  [actions.CHECK_FOR_EVENT_OVERLAP_SUCCESS]: (state, action) => {
    const newState = {};
    const newEventCreation = {};
    Object.assign(newEventCreation, state.eventCreation, {
      overlappingEvents: action.events,
    });
    Object.assign(newState, state, { eventCreation: newEventCreation });
    return newState;
  },
  [actions.CHECK_FOR_EVENT_OVERLAP_FAILURE]: (state, action) => {
    const newState = {};
    Object.assign(newState, state, { errorMessage: action.err });
    return newState;
  },
  [actions.SEARCH_PROMOTERS_SUCCESS]: (state, { promoters, promoterName }) => {
    const newSearchedPromoters = promoters
      .map((promoter) => {
        return { name: promoter.label, id: promoter.id };
      })
      .filter((promoter) =>
        promoter.name.toLowerCase().includes(promoterName.toLowerCase())
      );
    const newState = { ...state, searchedPromoters: newSearchedPromoters };
    return newState;
  },
  [actions.ADD_PROMOTER]: (state, { promoter }) => {
    const newPromoters = state.eventCreation.axsEvent.promoters
      ? state.eventCreation.axsEvent.promoters.slice(0)
      : [];
    newPromoters.push({
      promoterId: Number(promoter.id),
      promoterName: promoter.name,
      name: promoter.name,
    });
    const newState = {
      ...state,
      eventCreation: {
        ...state.eventCreation,
        axsEvent: {
          ...state.eventCreation.axsEvent,
          promoters: newPromoters,
        },
      },
    };
    return newState;
  },
  [actions.REMOVE_PROMOTER]: (state, { promoter }) => {
    let newPromoters = state.eventCreation.axsEvent.promoters
      ? state.eventCreation.axsEvent.promoters.slice(0)
      : [];
    newPromoters = newPromoters.filter(
      (e) => e.promoterName !== promoter.promoterName
    );
    const newState = {
      ...state,
      eventCreation: {
        ...state.eventCreation,
        axsEvent: {
          ...state.eventCreation.axsEvent,
          promoters: newPromoters,
        },
      },
    };
    return newState;
  },
  [actions.SET_IS_SAVING_FLAG]: (state, { setting }) => {
    return {
      ...state,
      isSaving: setting,
    };
  },
  [actions.SET_IS_LOADING_FLAG]: (state, { setting }) => {
    return Object.assign({}, state, { isLoading: setting });
  },
  [actions.SEARCH_PROMOTERS_FAILURE]: (state, { errorMessage }) => {
    const newState = {};
    Object.assign(newState, state, { errorMessage: errorMessage });
    return newState;
  },
  [actions.LOAD_EVENT_DETAILS]: (state) => {
    return Object.assign({}, state);
  },
  [actions.LOAD_EVENT_DETAILS_BEGIN]: (state) => {
    return Object.assign({}, state, { isLoading: true });
  },
  [actions.LOAD_EVENT_DETAILS_SUCCESS]: (state, action) => {
    const event = receiveAndFormatEvent(action.event, action.flag);
    const zones = receiveAndFormatZones(event, action.flag);
    Object.assign(event, { zones });

    return Object.assign({}, state, {
      event,
      isLoading: false,
      initialLoadOfEDP: true,
      eventInView: action.event.id,
      lastFetched: new Date(),
    });
  },
  [SET_LD_FLAG]: (state, action) => {
    return {
      ...state,
      promoterEnabled: { value: action.value, isLoaded: action.isLoaded },
    };
  },
  [actions.SET_SHORT_CODES_FLAG]: (state, action) => {
    return {
      ...state,
      shortCodesEnabled: { value: action.value, isLoaded: action.isLoaded },
    };
  },
  [actions.SET_LISTING_EXPIRATION_FLAG]: (state, action) => {
    return {
      ...state,
      listingExpirationEnabled: {
        value: action.value,
        isLoaded: action.isLoaded,
      },
    };
  },
  [actions.LOAD_EVENT_DETAILS_ABORT]: (state) => {
    const newState = {};
    Object.assign(newState, state, { isLoading: false });
    return newState;
  },
  [actions.LOAD_PORTAL_EVENT_DETAILS]: (state, action) => {
    const dates = receiveAndFormatPortalOnlyEvent(action.portalEvent);
    const event = {
      dates,
      id: action.portalEvent && action.portalEvent.aXSEvent.eventId,
      eventName:
        action.portalEvent && action.portalEvent.aXSEvent.title.eventTitleText,
      aXSEvent: action.portalEvent && action.portalEvent.aXSEvent,
      venueId: action.portalEvent && action.portalEvent.venueId,
      axsVenueId: action.portalEvent && action.portalEvent.aXSVenueId,
      venue: action.portalEvent && action.portalEvent.venue,
      timeZone: action.portalEvent && action.portalEvent.timeZone,
      portalEvent: true,
    };
    return { ...state, event, isLoading: false };
  },
  [actions.LOAD_EVENT_DETAILS_FAILURE]: (state, action) => {
    //temp
    JSON.stringify(action.err);
    return Object.assign({}, state, { isLoading: false, error: action.err });
  },
  [actions.DIRECT_TO_OFFERS]: (state) => {
    return Object.assign({}, state);
  },
  [actions.DIRECT_TO_ADD_ZONES]: (state) => {
    return Object.assign({}, state);
  },
  [actions.DIRECT_TO_OFFER_SETTINGS]: (state) => {
    return Object.assign({}, state);
  },
  [actions.DIRECT_TO_CREATE_EDIT_EVENT]: (state) => {
    return Object.assign({}, state, { isLoading: true });
  },
  [actions.REDIRECT_TO_EVENTS]: () => {
    return Object.assign({}, initialState);
  },
  [actions.GET_OFFER_BY_ID]: (state) => {
    return Object.assign({}, state, { isLoading: true });
  },
  [actions.GET_OFFER_BY_ID_SUCCESS]: (state) => {
    return Object.assign({}, state, { isLoading: false });
  },
  [actions.GET_OFFER_BY_ID_FAILURE]: (state) => {
    return Object.assign({}, state, { isLoading: false });
  },
  [actions.UPDATE_OFFER]: (state, action) => {
    const newState = {};
    const newEvent = {};
    const offerZoneId = action.offer.zoneId;
    const offerId = action.offer.id;

    const updateZones = state.event.zones.map((zone) => {
      if (zone.id === offerZoneId) {
        const zoneOffers = zone.offers.filter((offer) => offer.id !== offerId);
        const newOffer = Object.assign({}, action.offer);
        zone.offers = [...zoneOffers, newOffer];
        return zone;
      }
    });
    Object.assign(newEvent, state.event, { zones: updateZones });
    Object.assign(newState, state, { event: newEvent });
    return newState;
  },
  [actions.TOGGLE_ACCESS_CONTROL]: (state, action) => {
    const event = state.event;
    const index = findIndex(event.zones, { id: Number(action.zoneId) });
    const newEvent = state.event;
    newEvent.zones[index].enableAccessControl = !newEvent.zones[index]
      .enableAccessControl;

    const newState = {};
    Object.assign(newState, state, { event: newEvent });
    return newState;
  },
  [actions.SAVE_ZONE_SETTINGS]: (state) => {
    return Object.assign({}, state, {});
  },
  [actions.CANCEL_ZONE_SETTINGS]: (state) => {
    return Object.assign({}, state, {});
  },
  [actions.CANCEL_ADMISSIONS]: (state) => {
    return Object.assign({}, state, {});
  },
  [actions.REDIRECT_TO_PATH]: (state) => {
    return Object.assign({}, state, {});
  },
  [actions.SAVE_ZONE_BEGIN]: (state) => {
    return Object.assign({}, state, {});
  },
  [actions.SAVE_ZONE_FAILURE]: (state) => {
    return Object.assign({}, state, {});
  },
  [actions.SAVE_ZONE_SUCCESS]: (state, action) => {
    const event = cloneDeep(state.event);
    const index = findIndex(state.event.zones, {
      id: Number(action.data.ZoneId),
    });
    event.zones[index].description = action.data.Name;
    event.zones[index].accessControlStartDateTime =
      action.data.AccessControlStartDate;
    event.zones[index].accessControlEndDateTime =
      action.data.AccessControlEndDate;
    event.zones[index].enableAccessControl = action.data.EnableAccessControl;
    event.zones[index].venueMapId = action.data.VenueMapId;
    return Object.assign({}, state, { event: event });
  },
  [actions.SAVE_FLASHSEAT_BEGIN]: (state) => {
    return Object.assign({}, state, {});
  },
  [actions.SAVE_FLASHSEAT_FAILURE]: (state) => {
    return Object.assign({}, state, {});
  },
  [actions.LOAD_TEMPLATE_BASE_BEGIN]: (state) => {
    const newState = {};
    Object.assign(newState, state, {
      isLoading: true,
      isBaseEventLoading: true,
    });
    return newState;
  },
  [actions.LOAD_TEMPLATE_BASE_SUCCESS]: (state, action) => {
    const newState = {};
    Object.assign(newState, state, {
      baseTemplate: action.template,
      isLoading: false,
    });
    return newState;
  },
  [actions.LOAD_TEMPLATE_BASE_FAILURE]: (state) => {
    const newState = {};
    Object.assign(newState, state, { isLoading: false });
    return newState;
  },
  [actions.LOAD_PORTAL_TEMPLATE_BASE_BEGIN]: (state) => {
    const newState = {};
    Object.assign(newState, state, { isLoading: true });
    return newState;
  },
  [actions.LOAD_PORTAL_TEMPLATE_BASE_SUCCESS]: (state, action) => {
    const newState = {};
    Object.assign(newState, state, {
      baseTemplate: action.template,
      isLoading: false,
    });
    return newState;
  },
  [actions.LOAD_PORTAL_TEMPLATE_BASE_FAILURE]: (state) => {
    const newState = {};
    Object.assign(newState, state, { isLoading: false });
    return newState;
  },
  [actions.LOAD_TEMPLATE_BASE_EVENT_DATA_BEGIN]: (state) => {
    const newState = {};
    Object.assign(newState, state, {
      isLoading: true,
      isBaseEventLoading: true,
    });
    return newState;
  },
  [actions.LOAD_TEMPLATE_BASE_EVENT_DATA_SUCCESS]: (state, action) => {
    const newState = {};
    const templateBaseEventData = receiveAndFormatTemplateBaseEvent(
      action.templateBaseEventData,
      action.axsEvent,
      action.rdatFlag
    );
    Object.assign(newState, state, {
      templateBaseEventData,
      isLoading: false,
      isBaseEventLoading: false,
    });
    return newState;
  },
  [actions.LOAD_TEMPLATE_BASE_EVENT_DATA_FAILURE]: (state, action) => {
    const newState = {};
    Object.assign(newState, state, {
      error: action.failureMessage,
      isLoading: false,
      isBaseEventLoading: false,
    });
    return newState;
  },
  [actions.LOAD_PORTAL_TEMPLATE_BASE_EVENT_DATA_SUCCESS]: (state, action) => {
    const newState = {};
    // Take the CMS data and merge in any RDATs from the template base event:
    const templateBaseEventData = Object.assign(
      {},
      action.templateBaseEventData
    );
    const event = receiveAndFormatPortalTemplateBaseEvent(
      templateBaseEventData,
      action.axsEvent,
      action.rdatFlag
    );
    event.axsEvent = action.axsEvent;
    Object.assign(newState, state, {
      event,
      templateBaseEventData,
      isLoading: false,
    });
    return newState;
  },
  [actions.ADD_TEMPLATE_OFFERS_TO_EDP]: (state, action) => {
    const newState = {};
    const currAvailOffers = cloneDeep(state.availEventOffers);
    action.offers.forEach((offer) => {
      const eventLookupId = state.event.lookupId;
      const offerSubId = offer.lookupId.split('_');
      offer.lookupId = offerSubId
        ? eventLookupId + '_' + offerSubId.slice(1).join('_')
        : offer.lookupId;
      // LINK OFFER WITH ZONE USING PREVZONEID
      currAvailOffers.push(Object.assign({}, offer, { incomplete: true }));
    });
    const linkedOffersWithPreviousZoneId = currAvailOffers.map((offer) => {
      const foundPrevZone =
        find(state.event.zones, { previousZoneId: offer.zoneId }) || null;
      // not sure what to do in the case that this fails and isn't found
      return Object.assign(
        {},
        offer,
        { zoneId: foundPrevZone ? foundPrevZone.id : offer.zoneId },
        {
          zoneDescription: foundPrevZone
            ? foundPrevZone.description
            : offer.zoneDescription,
        }
      );
      // if we don't find a match on the previoudZoneId, use the zoneId currently on the offer
    });
    Object.assign(newState, state, {
      availEventOffers: linkedOffersWithPreviousZoneId,
    });
    return newState;
  },
  [actions.FLAG_OFFER_IS_INCOMPLETE]: (state) => {
    const newState = {};
    Object.assign(newState, state);
    return newState;
  },
  [actions.CLEAR_EVENT]: (state) => {
    return Object.assign({}, state, {
      event: initialState.event,
      eventCreation: initialState.eventCreation,
      isLoading: false,
      initialLoadOfEDP: false,
    });
  },
  [actions.STORE_OFFER_TEMPLATE_ID]: (state, action) => {
    const newState = {};
    Object.assign(newState, state, { offerTemplateId: action.uniqueId });
    return newState;
  },
  [actions.CLEAR_TEMPLATE_OFFERS]: (state) => {
    const newState = {};
    Object.assign(newState, state, {
      availEventOffers: [],
      templateBaseEventData: {},
      baseTemplate: {},
    });
    return newState;
  },
  [actions.RESET_OFFER_TEMPLATE_ID]: (state) => {
    const newState = {};
    Object.assign(newState, state, { offerTemplateId: '' });
    return newState;
  },
  [actions.REMOVE_TEMPLATE_OFFER]: (state) => {
    const newState = {};
    const filteredAvailEventOffers = state.availEventOffers.filter((offer) => {
      return offer.uniqueId !== state.offerTemplateId;
    });
    Object.assign(newState, state, {
      availEventOffers: filteredAvailEventOffers,
    });
    return newState;
  },
  [actions.UPDATE_ORIGINAL_TEMPLATE_ID]: (state, action) => {
    const event = cloneDeep(state.event);
    event.originalTemplateId = action.originalTemplateId;
    return Object.assign({}, state, { event: event });
  },
  [actions.DIRECT_TO_EDP]: (state) => {
    return { ...state };
  },
  [actions.CLEAR_BASE_TEMPLATE]: (state) => {
    return Object.assign({}, state, { baseTemplate: {} });
  },
  [actions.CLEAR_TEMPLATE_BASE_EVENT_DATA]: (state) => {
    return Object.assign({}, state, { templateBaseEventData: {} });
  },
  [actions.DIRECT_TO_EVENT]: (state) => {
    return Object.assign({}, state);
  },
  [actions.LOAD_TICKET_TEXT_TEMPLATES_SUCCESS]: (state, action) => {
    return { ...state, ticketTextTemplates: action.templates };
  },
  [actions.LOAD_TICKET_TEXT_TEMPLATES_FAILURE]: (state, action) => {
    return { ...state, error: action.failureMessage };
  },
  [actions.SET_TICKET_TEXT_TEMPLATE]: (state, action) => {
    const event = cloneDeep(state.event);
    const zone = find(event.zones, { id: Number(action.zoneId) });
    zone.selectedTicketTemplate = action.id;
    return { ...state, event };
  },
  [actions.SET_ONSALE_DATE]: (state, { date }) => {
    const event = cloneDeep(state.event);
    event.generalOnsaleDate = date;
    return { ...state, event };
  },
  [actions.SET_LAST_SAVED_OFFER]: (state, { offerId }) => {
    return { ...state, lastSavedOffer: offerId };
  },
  [actions.SET_IMAGE]: (state, { data }) => {
    return { ...state, media: data };
  },
  [actions.SET_IMAGE_SQUARE]: (state, { data }) => {
    return { ...state, mediaSquare: data };
  },
  [actions.SET_IMAGE_FACEBOOK]: (state, { data }) => {
    return { ...state, mediaFacebook: data };
  },
  [actions.DELETE_MEDIA]: (state, { mediaId }) => {
    const event = cloneDeep(state.eventCreation);
    const axsEvent = event.axsEvent;
    const media = axsEvent.media;
    if (media && Object.keys(media).length) {
      media[mediaId].mediaDelete = true;
      media[mediaId].deleteSecondary = true;
    }
    return Object.assign({}, state, { eventCreation: event });
  },
  [actions.GET_SITES_BEGIN]: (state) => {
    return Object.assign({}, state);
  },
  [actions.GET_SITES_FAILURE]: (state) => {
    return Object.assign({}, state);
  },
  [actions.DIRECT_TO_ADMISSIONS]: (state) => {
    return Object.assign({}, state);
  },
  [actions.GET_SITES_SUCCESS]: (state, { sites, isNewEvent }) => {
    const newState = {};
    const updatedEventCreation = {};
    const selectedSites = Object.assign(
      {},
      state.eventCreation.axsEvent ? state.eventCreation.axsEvent.siteData : {}
    );
    const allSites = Object.assign([], sites);

    // For existing event, use the Selected Site data from Services.
    if (!isNewEvent) {
      allSites.map((site) => {
        site.default =
          selectedSites[Number(site.id)] === site.name
            ? 'selected'
            : 'unselected';
        return site;
      });
    }

    Object.assign(updatedEventCreation, state.eventCreation, {
      visibleOnSites: allSites,
      isPublicEDP: getIsPublicEDP(isNewEvent, selectedSites),
    });
    Object.assign(newState, state, { eventCreation: updatedEventCreation });
    return newState;
  },
  [actions.LOAD_CMS_REVISIONS_BEGIN]: (state) => {
    return { ...state };
  },
  [actions.LOAD_CMS_REVISIONS_SUCCESS]: (state, action) => {
    const revisions = action.data.results;
    return {
      ...state,
      cmsRevisions: revisions,
    };
  },
  [actions.LOAD_CMS_REVISIONS_FAILURE]: (state, action) => {
    return { ...state, errorMessage: action.err };
  },
  [actions.SEARCH_TAGS_BEGIN]: (state) => {
    return { ...state };
  },
  [actions.SEARCH_TAGS_FAILURE]: (state) => {
    return { ...state };
  },
  [actions.AUTO_COMPLETE_ARTISTS_RESPONSE]: (state, action) => {
    const tags = [...action.data.performer.matches].map((tag) => {
      return {
        text: tag.performer_title,
        value: tag.performer_id,
        key: tag.performer_id,
        categories: tag.categories,
      };
    });
    const newState = {
      ...state,
      eventCreation: {
        ...state.eventCreation,
        tags: {
          ...state.eventCreation.tags,
          [action.key]: tags,
        },
      },
    };
    return newState;
  },
  [actions.ADD_TAG]: (state, { tag, key }) => {
    const currTags = state.eventCreation.axsEvent.associations[key];
    const existingTag = find(currTags, { performerId: tag.performerId });
    const newTags = !existingTag ? [...currTags, tag] : currTags;

    return {
      ...state,
      eventCreation: {
        ...state.eventCreation,
        axsEvent: {
          ...state.eventCreation.axsEvent,
          associations: {
            ...state.eventCreation.axsEvent.associations,
            [key]: newTags,
          },
        },
      },
    };
  },
  [actions.REMOVE_TAG]: (state, { tag, key }) => {
    let newTags = state.eventCreation.axsEvent.associations[key]
      ? Object.keys(state.eventCreation.axsEvent.associations[key]).map(
          (fKey) => state.eventCreation.axsEvent.associations[key][fKey]
        )
      : [];
    newTags = newTags.filter((e) => {
      return e.name !== tag.name;
    });
    const {
      majorCategoryId1,
      majorCategoryId2,
      majorCategoryId3,
      minorCategoryId1,
      minorCategoryId2,
      minorCategoryId3,
    } =
      key === 'headliners' ? sortGenres(newTags) : state.eventCreation.axsEvent;

    const newState = {
      ...state,
      eventCreation: {
        ...state.eventCreation,
        axsEvent: {
          ...state.eventCreation.axsEvent,
          majorCategoryId1,
          majorCategoryId2,
          majorCategoryId3,
          minorCategoryId1,
          minorCategoryId2,
          minorCategoryId3,
          associations: {
            ...state.eventCreation.axsEvent.associations,
            [key]: newTags,
          },
        },
      },
    };
    return newState;
  },
  [actions.REMOVE_PRICE_CODE_FROM_EVENT]: (state, { zoneId, priceCodeId }) => {
    if (zoneId === undefined || priceCodeId === undefined) return;
    //Using parseInt to protect against 0 matching with empty string
    //within the 'findIndex' function.
    zoneId = parseInt(zoneId);
    priceCodeId = parseInt(priceCodeId);
    const eventZones = [...state.event.zones];
    const zoneIndex = eventZones.findIndex((z) => zoneId === parseInt(z.id));
    if (zoneIndex === -1) return;
    const eventZone = { ...eventZones[zoneIndex] };
    eventZones[zoneIndex] = eventZone;
    eventZone.priceCodes = [...eventZone.priceCodes];
    const index = eventZone.priceCodes.findIndex(
      (priceCode) => priceCodeId === parseInt(priceCode.id)
    );
    if (index !== -1) {
      eventZone.priceCodes.splice(index, 1);
    }
    const newState = {
      ...state,
      event: {
        ...state.event,
        zones: eventZones,
      },
    };
    return newState;
  },
  [actions.ADD_PRICE_CODES_TO_EVENT]: (state, { zoneId, newPriceCodes }) => {
    if (zoneId === undefined || !newPriceCodes) return;
    //Using parseInt to protect against 0 matching with empty string
    //within the 'findIndex' function.
    zoneId = parseInt(zoneId);
    const eventZones = [...state.event.zones];
    const zoneIndex = eventZones.findIndex((z) => zoneId === parseInt(z.id));
    if (zoneIndex === -1) return;
    const eventZone = { ...eventZones[zoneIndex] };
    eventZones[zoneIndex] = eventZone;
    eventZone.priceCodes = [...eventZone.priceCodes];
    for (const newPriceCode of newPriceCodes) {
      eventZone.priceCodes.push(newPriceCode);
    }

    const newState = {
      ...state,
      event: {
        ...state.event,
        zones: eventZones,
      },
    };
    return newState;
  },
  [actions.SET_HAS_MODIFIED_OFFERS]: (state, { setting }) => {
    if (typeof setting !== 'boolean') return state;

    return {
      ...state,
      hasModifiedOffers: setting,
    };
  },
  [actions.SELECT_EVENT_TYPE_FROM_DROPDOWN]: (state, action) => {
    const newState = {};
    const eventCreation = Object.assign(state.eventCreation, {
      selectedEventCategory: action.eventCategory,
    });
    Object.assign(newState, state, { eventCreation });
    return newState;
  },
  [actions.SELECT_SEASON_TYPE_FROM_DROPDOWN]: (state, action) => {
    const newState = {};
    const eventCreation = Object.assign(state.eventCreation, {
      selectedSeasonCategory: action.seasonCategory,
    });
    Object.assign(newState, state, { eventCreation });
    return newState;
  },
  [actions.FETCH_EMAIL_TEMPLATES_BEGIN]: (state) => {
    const newState = {};
    Object.assign(newState, state);
    return newState;
  },
  [actions.FETCH_EMAIL_TEMPLATES_SUCCESS]: (state, action) => {
    const newState = {};
    Object.assign(newState, state, { emailTemplates: action.emailTemplates });
    return newState;
  },
  [actions.FETCH_TAX_PROFILE_BEGIN]: (state) => {
    const newState = {};
    Object.assign(newState, state);
    return newState;
  },
  [actions.FETCH_TAX_PROFILE_SUCCESS]: (state, action) => {
    const newState = {};
    Object.assign(newState, state, { taxProfiles: action.taxProfiles });
    return newState;
  },
  [actions.HANDLE_CREATE_CMS_EVENT]: (state) => {
    const newState = {};
    const eventCreation = Object.assign(state.eventCreation, {
      axsEvent: initialState.eventCreation.axsEvent,
    });
    Object.assign(newState, state, { eventCreation });
    return newState;
  },
};

const eventCreationInitialState = {
  dates: {
    flashDeliveryStartDate: {
      date: '',
      fieldId: FLASH_FIELD_ID,
    },
    standardDeliveryDate: {
      date: '',
      fieldId: STANDARD_DELIVERY_DATE_FIELD_ID,
    },
    eTicketStartDate: {
      date: '',
      fieldId: ETICKET_FIELD_ID,
    },
    announcementDate: {
      date: '',
      fieldId: ANNOUNCEMENT_FIELD_ID,
    },
    expirationDate: {
      date: '',
      fieldId: EXPIRATION_DATE_FIELD_ID,
    },
    generalOnsaleDate: {
      date: '',
      fieldId: ONSALE_FIELD_ID,
    },
    eventEndDate: {
      date: '',
      fieldId: END_FIELD_ID,
    },
    eventStartDate: {
      date: '',
      fieldId: START_FIELD_ID,
    },
  },
  tags: {},
  axsVenueId: '',
  axsEvent: {
    associations: {
      headliners: [],
      supportingActs: [],
    },
    doorDate: {
      date: moment().format('YYYY-MM-DDTHH:00:00'),
      fieldId: DOOR_DATE_FIELD_ID,
    },
    promoters: [],
    presentedByText: '',
    tour: '',
    ticketing: {},
    ticketPrice: '',
    doorPrice: '',
    publishStatus: 1,
  },
  eventId: '',
  eventName: '',
  eventInView: '',
  initialLoadOfEDP: false,
  isPublicEDP: true,
  flashDeliveryStartDate: '',
  timeZone: '',
  eventLookupId: '',
  media: '',
  mediaSquare: '',
  mediaFacebook: '',
  mediaURL: '',
  originalTemplateId: '',
  overlappingEvents: [],
  offerTemplateId: '',
  newOriginalTemplateId: '',
  templateId: '',
  templateName: '',
  templateBaseEventData: {},
  ticketTextTemplates: [],
  venue: '',
  venueId: '',
  venueCode: '',
  visibleOnSites: [],
  axsManagerId: '',
  axsManagerOptions: [],
  venueManagerId: '',
  venueManagerOptions: [],
  shortCodeId: '',
  shortCodeOptions: [],
  priceLevelOverrideInManifest: true,
};

const eventCreationInitialSerialized = JSON.stringify(
  eventCreationInitialState
);

export const initialState = {
  lastFetched: '',
  availEventOffers: [],
  alreadyAutoPublished: [],
  baseTemplate: {},
  cmsRevisions: [],
  endDate: '',
  error: '',
  promoterEnabled: {},
  shortCodesEnabled: {},
  listingExpirationEnabled: {},
  errorMessage: '',
  isFetchingTemplates: false,
  isLoading: false,
  isLoadingTemplate: false,
  isSaving: false,
  isSavingPortalEvent: false,
  isSavingCMSEvent: false,
  importedTemplateSuccessStep1: false,
  isUniqueEventLookupId: true,
  lastSavedOffer: 0,
  eventLookupId: '',
  venueMaps: [],
  emailTemplates: [],
  taxProfiles: [],
  searchedHeadliners: [],
  searchedSupportingActs: [],
  searchedPromoters: [],
  eventInView: '',
  initialLoadOfEDP: false,
  newOriginalTemplateId: '',
  offerTemplateId: '',
  templateBaseEventData: {},
  ticketTextTemplates: [],
  hasModifiedOffers: false,
  event: {
    AccessControlEndDateTime: { date: '', fieldId: ACCESS_END_FIELD_ID },
    AccessControlStartDateTime: { date: '', fieldId: ACCESS_START_FIELD_ID },
    onsaleDateTime: '',
    generalOnsaleDate: '',
    defaultPriceLevels: [],
    endDate: '',
    eventName: '',
    eventHasBeenModified: false,
    zoneHasBeenModified: false,
    offers: [],
    originalTemplateId: '',
    priceCodes: [],
    startDate: '',
    timeZone: '',
    Venue: '',
    zones: [],
    dates: {
      flashDeliveryStartDate: {
        date: '',
        fieldId: FLASH_FIELD_ID,
      },
      eTicketStartDate: {
        date: '',
        fieldId: ETICKET_FIELD_ID,
      },
      standardDeliveryDate: {
        date: '',
        fieldId: STANDARD_DELIVERY_DATE_FIELD_ID,
      },
      announcementDate: {
        date: '',
        fieldId: ANNOUNCEMENT_FIELD_ID,
      },
      generalOnsaleDate: {
        date: '',
        fieldId: ONSALE_FIELD_ID,
      },
      eventEndDate: {
        date: '',
        fieldId: END_FIELD_ID,
      },
      eventStartDate: {
        date: '',
        fieldId: START_FIELD_ID,
      },
      accessControlStartDate: {
        date: '',
        fieldId: ACCESS_START_FIELD_ID,
      },
      accessControlEndDate: {
        date: '',
        fieldId: ACCESS_END_FIELD_ID,
      },
    },
  },
  eventCreation: eventCreationInitialState,
};

export default function eventDetailsReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];

  return handler ? handler(state, action) : state;
}



// WEBPACK FOOTER //
// ./src/routes/EventDetails/modules/eventDetails.js